import React , {Suspense, lazy} from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import _get from 'lodash/get';
import * as actions from '../../../actions/productData';
import properties from '../../../modules/ajio-util/properties';
import queryUtil from '../../../modules/ajio-util/query';
import LazyImage from '../LazyImage';
import { getFormattedPrice, isMarketing } from '../../../utils/pdp';
import { isCatalogNameInFirebaseStore, isCopilotReferrer } from '../../../utils/common';
import elementSize from '../../../modules/ajio-util/dom/elementSize';
import { setGridConfig, setGridConfigPDP } from '../../../actions/shared/productGrid';
import {
  removeProductFromWishlist,
  openSizeModal,
  addProductToWishlist,
  removeProductFromWishlistPDP,
  setWishlistNotify
} from '../../../wishlist/actions/wishlist';
const EditSizeUpdate = lazy(() => import('../../../cart/components/responsive/EditSizeUpdate'));
import { buildQuery, addCustomerType, getProductImagesForPlp, isExclusiveDatePast } from '../../../utils/products';
import {
  trackProductItemClick,
  trackRemoveItemFromWishList,
  trackProductItemHover
} from './eventLisiting';
import {
  getPlpSizesFlag,
  getNewSizeRevampFlag,
  getShowBrandSizeFlag,
  getLuxeFlags
} from '../../../Flags/selectors';
import { DealOfTheDayTag, DealOfTheDayTimerTag } from '../DodCommonComponent/DodCommonComponent';
import { IsDealStart, IsDealEnd } from '../DodCommonComponent/DodComponentFunctionality';
import cleverTapPushEvent from '../../../modules/ajio-util/cleverTap/eventUtils';
import CLEVERTAP_EVENT_NAMES from '../../../modules/ajio-util/cleverTap/eventConstants';
import { readCookie, createCookie } from '../Cookie';
import { getSizeDetail } from '../../../cart/actions/cart';
import { showLoader, hideLoader } from '../../../actions/shared/loader';
import { fetchSizeAndBrandSize } from '../../../utils/StandardSizeUtils';
import Icon from '../../../refresh/atoms/Icon';
import Button from '../../../refresh/atoms/button';
import { signInCheck } from '../CheckUserStatus';
import Constant from '../../../utils/AjioWalletConstants';
import getPriceStripped, { displayValue, formatPrice } from '../../../refresh/utils/priceUtils';
import DodTimer from '../DodCommonComponent/DodTimer';
import { gtmEventPush, luxeGtmProductClick, luxeGtmAddToCart, segmentEventPush, getProductItemPDP, getProductItem } from '../../../modules/ga/GTMdatalayer';
import PriceRevealPLP from './priceRevealPLP/PriceRevealPLP';
import { getPriceRevealSaleDuration } from '../PriceRevealPLPBanner/priceRevealUtil';
import { getCurrentStore } from '../../../refresh/selectors/metaData';
import Dialog from '../../../refresh/molecules/Dialog';
import luxeScreens from '../../../refresh/constants/luxeScreenType';
import getWishlistPriceDropData from '../../../refresh/utils/wishlistPriceDropUtils';
import { displayValueWithoutDecimal } from '../../../utils/price';
// const DodTimer  =  React.lazy(() => import(/* webpackChunkName: "static/chunk/mobile/DodCommonComponent" */ '../DodCommonComponent/DodTimer'));
import { loadWishlistOptionCodesAPI } from '../../../wishlist/actions/wishlist';
import luxeList from '../../../refresh/constants/luxeScreenType';
import getPlpExtendedBannerImages from '../../../refresh/selectors/plpExtendedBanner';
import { jioAdsAddtoWishList, jioAdsRemoveFromWishList } from '../../../utils/jioAds';
import { Feature, Variant } from '../../../refresh/organism/ABFeature';
import { getVariant, getFeatureVariant } from '../../../refresh/organism/ABFeature/Feature';
import { getTagValueFromTagEngine, getPriceLableFromTagEngine, getPLPTagV2FromPosition } from '../../../utils/product';
import { InView } from 'react-intersection-observer'
import { addToBag } from '../../../../src/refresh/pages/CartPage/Constants';
import { deliveryMethod as DELIVERY_METHOD } from '../../../refresh/constants/ordersData.constants';
import { redirectedFromVideoBanner, redirectedFromFloatingWidget } from '../../../utils/banner';
import { getShowSimilarProductsForPlp, getViewTypeFlag, getShowSimilarProducts, getGA4AJIOEnable, getGiftWithProductEnable, getGiftWithProductConfig,getEnableComingSoonProducts, getAjiogramInterventionsConfig, getUrgencyDriverV2PLPEnable } from '../../../../src/refresh/selectors/featureFlagsSelector';
import { getEnableRating, getEnableRatingLabelPLP, getEnableRatingLabelWishlist, getStoresForHidingMRP, getPriorityDeliveryPhase2Flag, getPriorityDeliveryConfig, getPriorityDeliverySLPTagsConfig, getRushDeliveryFlag } from '../../../refresh/selectors/featureFlagsSelector';
import AggregatedRatingTag from '../../../refresh/atoms/AggregatedRatingTag';
const PlpRatingWidget = lazy(() => import('../../../refresh/molecules/PlpRatingWidget'));
import LoadingHomeRate from '../../../refresh/atoms/LoadingHomeRate';
import { FLEEK_STORE } from '../../../constants/constant';
import { getPreviousSearchSource } from '../../../refresh/selectors/productpage';
import { replaceWithJioCDN } from '../../../../src/utils/imageHandling';
import { getAmplitudeVariantPayload } from '../../../utils/amplitudeCommon';

const similar_products_plp = getVariant('similar_products_plp', true);
const similarProductsVariant = similar_products_plp ? similar_products_plp : null;
const userId = decodeURIComponent(readCookie('U')) || '';
let oldHeight = 0;
const imageBaseUrl = properties.getProperty("imageBaseUrl");
const ProductScroller = lazy(() =>
  import(
    /* webpackChunkName: "static/chunk/mobile/ProductScroller" */ '../../../refresh/organism/ProductScroller'
  )
);
import className from 'classnames/bind';
import styles from '../../../refresh/organism/ProductScroller/index.pcss';
const cx = className.bind(styles);
var holdStarter = null;
var holdDelay = 300;
var holdActive = false;
export const ShowSizeDetail = ({ sizeVariants, more, fleek }) => {
  return (
    sizeVariants.length > 0 && (
      <div className="size-content">
        {sizeVariants.map((size, idx) => {
          return (
            <div className={fleek ? 'show-size fleek-show-size' : 'show-size'} key={idx}>
              {size}
            </div>
          );
        })}
        {more > 0 && <div className="show-more">{`+${more}`}</div>}
      </div>
    )
  );
};
class ProductCard extends React.Component {
  constructor(props) {
    super(props);
    this.productListContainer = null;
    this.state = {
      showSizePopup: false,
      variantOptions: _get(props, 'entity.variantOptions', []),
      sizeDisplayType: '',
      displayRemoveDialog: false,
      itemArr: [],
      isWishListed: this.setWishlistStatusFromLocal(),
      fromFloatingWidget: redirectedFromFloatingWidget(),
    };
    this.checkStore = props?.luxeFlags?.isThemeEnable == 'ON' && props?.currentStore === 'luxe';
    this.newStyle = props?.style.height
    this.couponApplicableText = 'Coupon Applicable';
    this.couponNotApplicableText = 'Coupon Not Applicable';
    this.modalRef = React.createRef();
    this.closeButtonRef = React.createRef();
    this.trapFocus = this.trapFocus.bind(this);
    this.previousActiveElement = null;
  }
  componentDidMount() {
    document.addEventListener('keydown', this.trapFocus);
    window.addEventListener('contextmenu', function (e) { e.preventDefault(); }, true);
    window.addEventListener('load', () => {
      const { msiteLuxe, newDesignLuxe, username, entities = {} } = this.props;
      const prdCode = localStorage.getItem('prdCode');
      const singleEntity = entities[prdCode] || {};
      const {
        fnlColorVariantData = {},
        price: { value: sp = 0 } = {},
        brickName = '',
        brickCategory = '',
        brickSubCategory = '',
      } = singleEntity;
      const { colorGroup = '' } = fnlColorVariantData;
      if (username) {
        if (prdCode) {
          this.props.addToWishlistApi(prdCode);
          console.log("TRACK POINT 3 ~ brickCategory:", brickCategory)
          console.log("TRACK POINT 3 ~ brickSubCategory:", brickSubCategory)
          console.log("TRACK POINT 3 ~ brickName:", brickName)
          jioAdsAddtoWishList({
            brickCategory,
            brickSubCategory,
            brickName,
            code: colorGroup || (typeof code == 'undefined' ? null : code),
            price: sp,
            quantity: 1
          });
          localStorage.removeItem('prdCode');
          this.props.loadWishlistOptionCodesAPI();
        }
        this.luxeSetGuestUserWishlistStatus();
      }
    });
    const { entity } = this.props;
    let extraImages = entity?.extraImages
    let imagesForScroller = [];
    extraImages?.length > 0 &&
      extraImages.forEach(obj => {
        obj?.images.forEach((img) => {
          imagesForScroller.push(img);
        }
        )
      });
    let result = getProductImagesForPlp(imagesForScroller);
    this.setState({ imagesForScroller: result })
    this.repositionWishlistButtons();
    this.repositionCartButtons();
    window.addEventListener('resize', this.repositionWishlistButtons());
    window.addEventListener('resize', this.repositionCartButtons());


    
  }
  componentDidUpdate(prevProps) {
    if (prevProps.products !== this.props.products || prevProps.changeView !== this.props.changeView) {
      this.repositionWishlistButtons();
    }
    this.repositionCartButtons();
    if ((prevProps.wishlistOptionCodeUpdates === false && this.props.wishlistOptionCodeUpdates === true) ||
      (prevProps.similarProductViewed === true && this.props.similarProductViewed === false)) {
      const status = this.setWishlistStatusFromLocal();
      this.setState({ isWishListed: status });
    }
    if (this.modalRef.current) {
      const firstElement = this.modalRef.current.querySelector(
        'button:not(:disabled), [href]:not([aria-disabled="true"]), input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex]:not([tabindex="-1"])'
      );
      if (firstElement) {
        firstElement.focus();
      }
    }
  }

  trapFocus = (event) => {
    if (!this.modalRef.current) return;
    const focusableElements = Array.from(
      this.modalRef.current.querySelectorAll(
        'button:not(:disabled), [href]:not([aria-disabled="true"]), input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex]:not([tabindex="-1"])'
      )
    ).filter((el) => !el.hasAttribute('disabled') && el.tabIndex !== -1);
    if (focusableElements.length === 0) return;

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (event.key === 'Tab') {
       if (!focusableElements.includes(document.activeElement)) {
        event.preventDefault();
        firstElement.focus();
        return;
      }
      if (event.shiftKey && document.activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
      } else if (!event.shiftKey && document.activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
    }
  };

  componentWillUnmount() {
    window.removeEventListener('resize', this.repositionWishlistButtons());
    window.removeEventListener('resize', this.repositionCartButtons());

    document.removeEventListener('keydown', this.handleTrapFocus);
    if (this.previousActiveElement) {
      this.previousActiveElement.focus();
    }
  }

repositionCartButtons() {
  const containers = document.querySelectorAll('.rilrtl-product-size');

  containers.forEach(container => {
    const parent = container.parentElement;
    const image_container = parent?.querySelector('.rilrtl-lazy-img')
    const image_container_height = image_container?.offsetHeight    
    if (!parent) return;

    // measure parent height (assuming it's the product card/image container)
    const height = this.newStyle 

    // const topPosition = this.checkStore ? `${height * 0.625}px` : `${height * 0.625}px`;
    const topPosition = `${image_container_height * 0.85}px`;
    const left = this.checkStore ? `10px` : `0`;

    Object.assign(container.style, {
      position: 'absolute',
      top: topPosition,
      left: left,
      zIndex: '2'
    });
  });
}



repositionWishlistButtons() {

  const containers = document.querySelectorAll('.wishilistContainer');

  const selectors = ['.imgHolder', '.luxeImgHolder', '.fleek-img-holder'];

  containers.forEach(container => {
    const code = container.dataset.code;
    if (!code) return;

    const selector = selectors
      .map(sel => `${sel}[data-code="${code}"]`)
      .join(', ');

    const imgHolder = document.querySelector(selector);
    if (!imgHolder) return;

    const height = imgHolder.offsetHeight;
    const topPosition = this.checkStore ? `${height * 0.86}px` : `${height * 0.855}px`;
    const right = this.checkStore ? `10px` : `0`;
    Object.assign(container.style, {
          position: 'absolute',
          top: topPosition,
          right: right,
          zIndex: '2'
        });
      });
}

  luxeSetGuestUserWishlistStatus() {
    const { entity: { fnlColorVariantData: { colorGroup = '' } = {} } = {} } = this.props
    const prdColorGroup = localStorage.getItem('prdColorGroup');
    if (prdColorGroup === colorGroup) {
      setTimeout(() => {
        this.addWishlistInLocal();
        this.setState({ isWishListed: true });
        localStorage.removeItem('prdColorGroup');
      }, 500);
    }
  }
  setWishlistStatusFromLocal() {
    const { entity: { fnlColorVariantData: { colorGroup = '' } = {} } = {}, username } = this.props
    const wishlistData = JSON.parse(localStorage.getItem('productWishlistStatusData'));
    if (!wishlistData || !username) return false;
    const userWishlistData = wishlistData[username];
    if (!userWishlistData) return false;
    const { codes = [] } = userWishlistData;
    if (codes.length === 0) return false;
    return codes.includes(colorGroup);
  }
  addWishlistInLocal() {
    const { entity: { fnlColorVariantData: { colorGroup = '' } = {} } = {}, username } = this.props;
    let wishlistData = JSON.parse(localStorage.getItem('productWishlistStatusData'));
    if (!wishlistData || !username) return false;
    const userWishlistData = wishlistData[username];
    if (!userWishlistData) return false;
    const { codes = [], updatedOn } = userWishlistData;
    if (codes.length === 0 || !codes.includes(colorGroup)) codes.push(colorGroup);
    const localData = {
      updatedOn,
      codes
    }
    let finalResponse = wishlistData;
    finalResponse[username] = localData;
    localStorage.setItem('productWishlistStatusData', JSON.stringify(finalResponse));
  }
  removeWishlistInLocal(code) {
    const { username } = this.props;
    let wishlistData = JSON.parse(localStorage.getItem('productWishlistStatusData'));
    if (!wishlistData || !username) return false;
    const userWishlistData = wishlistData[username];
    if (!userWishlistData) return false;
    const { codes = [], updatedOn } = userWishlistData;
    if (codes.length > 0) {
      const index = codes.indexOf(code);
      if (index >= 0) {
        codes.splice(index, 1);
        const localData = {
          updatedOn,
          codes
        }
        let finalResponse = wishlistData;
        finalResponse[username] = localData;
        localStorage.setItem('productWishlistStatusData', JSON.stringify(finalResponse));
      }
    }
  }
  wishlistSizeDetails = event => {
    if (event) event.preventDefault();
    const { entity: { variantOptions = [] } = {}, getSizeDetail, entity } = this.props;
    const code = _get(variantOptions, '[0].code', '');
    getSizeDetail(code);
  };
  openModal = (prodData, e) => {
    if (e) e.preventDefault();
    const { newDesignLuxe } = this.props;
    const { plp: { screenType = '', screenName = '' } = {} } = luxeScreens;
    this.props.openModal(prodData);
    if (newDesignLuxe) {
      gtmEventPush({
        event: 'plp_quick_view',
        event_category: 'product list interactions',
        event_action: 'quick view',
        store_type: 'luxe',
        screen_name: screenName,
        screen_type: screenType
      });
    }
  };
  showSize = variantOptions => {
    const { deviceType = '', openSizeModal } = this.props;
    const { sizeDisplayType = '' } = this.state;
    if (deviceType == 'desktop') {
      this.setState({ showSizePopup: true, variantOptions });
    } else {
      openSizeModal(variantOptions, sizeDisplayType);
    }
  };
  openSizeModal = async (e,name) => {
    if (e) e.preventDefault();
    const {
      entity: { variantOptions = [] } = {},
      showLoader,
      getSizeDetail,
      hideLoader,
      newSizeRevampFlag,
      newDesignLuxe
    } = this.props;
    const { openSizeModal } = this.state;
    try {
      let code = _get(variantOptions, '[0].code', '');
      showLoader('layout-loader');
      let response = await getSizeDetail(code);
      hideLoader('layout-loader');
      if (!response) {
        response = {};
      }
      if (typeof response.then === 'function') {
        response = await response;
      }
      const { baseOptions = [] } = response;
      let sizeVariant = baseOptions.filter(
        value => value && value.variantType === 'FnlSizeVariant'
      );
      let variantOptionQualifiersVal = sizeVariant[0].selected.variantOptionQualifiers;
      const { sizeType = '' } = fetchSizeAndBrandSize(
        variantOptionQualifiersVal,
        newSizeRevampFlag
      );
      let sizeDisplay;
      sizeDisplay = sizeType ? sizeType : '';
      const wishlistBagElement=document.getElementById(name)
      if(wishlistBagElement){
        this.previousActiveElement=wishlistBagElement;
      }
      this.setState({ sizeDisplayType: sizeDisplay });
      this.showSize(_get(sizeVariant, '[0].options', variantOptions));
    } catch (err) {
      hideLoader('layout-loader');
      this.showSize(variantOptions);
    }
  };
  mouseLeaveHandler = () => {
    this.setState({ showSizePopup: false });
    if(this.previousActiveElement){
      this.previousActiveElement.focus()
    }
  };

  quickViewMouseEnterHandler = () => {
    const {
      position,
      entity = {},
      location,
      pageType,
      freeTextSearch,
      previousSource
    } = this.props;

    const {
      code,
      price = {},
      discountPercent = '',
      fnlColorVariantData: { productTag = '' } = {}
    } = entity;

    const productTagEngineValue = getTagValueFromTagEngine(entity?.tags?.categoryTags || []);
    const newProductTagEngineValue = productTagEngineValue || productTag;

    const payload = {
      position,
      code,
      price,
      discountPercent,
      location,
      entity,
      pageType,
      freeTextSearch,
      previousSource,
      newProductTagEngineValue
    };

    trackProductItemHover(payload);
  };

  removeItemCleverTapEvent = () => {
    const { entity = {} } = this.props;
    let { location: { href = '' } = {} } = window;
    let {
      name = '',
      brickName = '',
      fnlColorVariantData = {},
      brickCategory,
      brickSubCategory,
      url,
      code = '',
      discountPercent,
      price: { value: sp = 0, formattedValue: formattedSp = '' } = {},
      wasPriceData: { value: mp = 0, formattedValue: formattedMp = '' } = {}
    } = entity;
    if (!discountPercent) {
      let discount;
      if (sp !== mp) {
        discount = Math.round(((mp - sp) / mp) * 100);
        discountPercent = `${discount}% off`;
      }
    }
    const newUrl = `${properties.getProperty('parentUrl')}${url}`;
    const { brandName = '', color = '' } = fnlColorVariantData;
    cleverTapPushEvent({
      eventName: CLEVERTAP_EVENT_NAMES.Remove_From_Closet,
      eventObj: {
        Product_name: name,
        Mrp: formattedMp,
        sp: formattedSp,
        Page_URL: newUrl,
        Category: brickCategory,
        SubCategory: brickSubCategory,
        Brand: brandName,
        user_id: userId != 'null' ? userId : 'anonymous',
        platform: 'MSITE',
        source: 'Wishlist_Page'
      }
    });
    let fleek = String(this.props.store).toLowerCase() === FLEEK_STORE.toLowerCase();
    if (this.props.pageType === 'wishlist') {
      // for wishlist we don't need theme changes 
      fleek = false;
    }
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const brandPageCode = urlParams.get('brandPageCode')
    if (fleek && brandPageCode) {
      gtmEventPush({
        event: 'delete_from_closet',
        event_category: 'remove_from_wishlist',
        event_action: 'removed succesfully',
        product_name: name,
        product_id: code.split('_') ? code.split('_')[0] : code,
        product_color: code.split('_') ? code.split('_')[1] : code,
        product_brand: brandName,
        product_price: formattedMp,
        product_discount: discountPercent,
        product_brick: brickName,
        page_url: href,
        page_name: 'blp screen',
        page_type: 'blp screen'
      });
    }
    else {
      gtmEventPush({
        event: 'remove_from_closet',
        product_name: name,
        product_id: code.split('_') ? code.split('_')[0] : code,
        product_color: code.split('_') ? code.split('_')[1] : code,
        product_catogory: brickCategory,
        product_brand: brandName,
        product_price: formattedMp,
        product_discount: discountPercent,
        page_url: href
      });
    }
    if (typeof ga === 'function') {
      window.ga && window.ga('send', {
        hitType: 'event',
        eventCategory: 'Page Interaction',
        eventAction: 'link click: pagelinks-1',
        eventLabel: `${name} ${brandName} ${brickCategory} ${formattedMp} ${discountPercent}`
      });
    }
  };
  addToNotifyWishlist=(e,propsData)=>{
    e.preventDefault();
    this.props.setWishlistNotify(true)
   const event_payload = {
    eventName: CLEVERTAP_EVENT_NAMES.Notify_Me,
    eventObj: {
      product_id: propsData?.entity?.code,
      product_name: propsData?.entity?.name,
      brick_name: propsData?.entity?.brickName,
      segment_name: propsData?.entity?.brickSubCategory,
      Brand_name: propsData?.entity?.fnlColorVariantData?.brandName,
      MRP: propsData?.entity?.price?.formattedValue
    }
  }
  cleverTapPushEvent(event_payload);
  }

  wishListApiCall = (code, store = '') => {
    const { entity = {}, addToWishlistApi, msiteLuxe, newDesignLuxe, ga4AjioEnable } = this.props;
    const { location: { href = '', pathname = '', search = '' } = {} } = window;
    const {
      name = '',
      fnlColorVariantData = {},
      price: { value: sp = 0 } = {},
      wasPriceData: { value: mp = 0, formattedValue: formattedMp = '' } = {},
    } = entity;
    let { discountPercent } = entity;
    const {
      brickName = '',
      brickCategory = '',
      brickSubCategory = '',
      catalogName = '',
      fnlProductData: { planningCategory = '' },
      url,
      verticalName,
      images
    } = entity;
    if (!discountPercent) {
      let discount;
      if (sp !== mp) {
        discount = Math.round(((mp - sp) / mp) * 100);
        discountPercent = `${discount}% off`;
      }
    }
    const { brandName = '', colorGroup = '' } = fnlColorVariantData;
    let fleek = String(store).toLowerCase() === FLEEK_STORE.toLowerCase();
    if (this.props.pageType === 'wishlist') {
      // for wishlist we dont need black theme changes 
      fleek = false;
    }
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const brandPageCode = urlParams.get('brandPageCode')
    if (fleek && brandPageCode) {
      if (ga4AjioEnable) {
        gtmEventPush({
          event: 'add_to_wishlist',
          isGA4: true,
          ecommerce: {
            currency: 'INR',
            value: Number(sp) || 0,
            items: [
              {
                item_id: code.split('_') ? code.split('_')[0] : code,
                item_name: name,
                discount: mp ? Number(mp - sp) || 0 : 0,
                index: 0,
                item_brand: brandName,
                item_category: brickCategory,
                item_list_name: 'plp screen',
                item_variant: colorGroup.split('_')[1],
                price: sp,
                quantity: 1,
                product_name: name,
                product_id: code.split('_') ? code.split('_')[0] : code,
                product_color: colorGroup.split('_')[1],
                product_brand: brandName,
                product_price: formattedMp,
                product_discount: discountPercent,
                product_brick: brickName
              }
            ],
          },
          event_category: 'add_to_whishlist',
          event_action: 'added sucessfully',
          page_url: href,
          page_name: 'blp screen',
          page_type: 'blp screen'
        });

        // Send Segment

        segmentEventPush({
          event: 'Product Wishlisted',
         // isGA4: true,
         //entity
          ecommerce: {            
            items: [ 
                {
                   ...getProductItemPDP(this.props.entity)
                }
            ],
          },
          event_category: 'add_to_whishlist',
          event_action: 'added sucessfully',
          //page_url: href,
          screen_name: 'blp screen',
          //screen_type: 'blp screen'
        });

      } else {
        gtmEventPush({
          event: 'add_to_closet',
          event_category: 'add_to_whishlist',
          event_action: 'added sucessfully',
          product_name: name,
          product_id: code.split('_') ? code.split('_')[0] : code,
          product_color: colorGroup.split('_')[1],
          product_brand: brandName,
          product_price: formattedMp,
          product_discount: discountPercent,
          product_brick: brickName,
          page_url: href,
          page_name: 'blp screen',
          page_type: 'blp screen'
        });

        // Send segment

        segmentEventPush({
          event: 'Product Wishlisted',
          event_category: 'add_to_whishlist',
          event_action: 'added sucessfully',
          products : [ {
                   ...getProductItemPDP(this.props.entity)
          }],          
          screen_name: 'blp screen',
          //page_type: 'blp screen'
        });
      }
    } else {
      if (ga4AjioEnable) {
        gtmEventPush({
          event: 'add_to_wishlist',
          isGA4: true,
          page_url: href,
          ecommerce: {
            currency: 'INR',
            value: Number(sp) || 0,
            items: [
              {
                item_id: code.split('_') ? code.split('_')[0] : code,
                item_name: name,
                discount: mp ? Number(mp - sp) || 0 : 0,
                index: 0,
                item_brand: brandName,
                item_category: brickCategory,
                item_list_name: 'plp screen',
                item_variant: colorGroup.split('_')[1],
                price: sp,
                quantity: 1,
                product_name: name,
                product_id: code.split('_') ? code.split('_')[0] : code,
                product_color: colorGroup.split('_')[1],
                product_brand: brandName,
                product_price: formattedMp,
                product_discount: discountPercent
              }
            ],
          }
        });

        // Send Segment
        segmentEventPush({
          event: 'Product Wishlisted',
          //isGA4: true,
          //page_url: href,
          ecommerce: {
            //currency: 'INR',
           // value: Number(sp) || 0,
            items: [
              {
                ...getProductItemPDP(this.props?.entity)
              }
            ],
          }
        });

      } else {
        gtmEventPush({
          event: 'add_to_closet',
          product_name: name,
          product_id: code.split('_') ? code.split('_')[0] : code,
          product_color: colorGroup.split('_')[1],
          product_brand: brandName,
          product_price: formattedMp,
          product_discount: discountPercent,
          page_url: href
        });

      
      }
    }
    const username = signInCheck();
    if (username) {
      if (this.state.isWishListed) {
        this.removeWishlistAlreadyExists();
        return;
      };
      addToWishlistApi(code);
      console.log("TRACK POINT 3 ~ brickCategory:", brickCategory)
      console.log("TRACK POINT 3 ~ brickSubCategory:", brickSubCategory)
      console.log("TRACK POINT 3 ~ brickName:", brickName)
      jioAdsAddtoWishList({
        brickCategory,
        brickSubCategory,
        brickName,
        code: colorGroup || code,
        price: sp,
        quantity: 1
      });
      cleverTapPushEvent({
        eventName: CLEVERTAP_EVENT_NAMES.Add_to_closet,
        eventObj: {
          MRP: mp,
          Name: name,
          SKU: colorGroup || code,
          Brand: brandName,
          Vertical: verticalName,
          Final_Price: sp,
          Brick: brickName,
          Category: brickCategory || planningCategory,
          Sub_Category: brickSubCategory,
          Image_URL: images[0] ? images[0].url : '',
          Size: '',
          Product_URL: url,
          Color: '',
          Catalog_Id: catalogName,
          user_id: userId !== 'null' ? userId : 'anonymous',
          platform: 'MSITE',
          source: 'PLP_Page'
        }
      });
      this.addWishlistInLocal();
      this.setState({ isWishListed: true });
      return;
    }
    localStorage.setItem('prdCode', code);
    localStorage.setItem('prdColorGroup', colorGroup);
    const urlPath = (pathname + search).trim();
    window.location.href = `/login?referrer=${urlPath}`;
  };
  fetchSimiliarStylesApiCall = (e, code, name, brandName) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.similarApiCall(similarProductsVariant, code, name, brandName);
  }
  onTouchStart = () => {
    holdStarter = setTimeout(function () {
      holdStarter = null;
      holdActive = true;
    }, 400);
  };
  onTouchEnd = (e, code, name, brandName, entity) => {
    const { plp: { screenType = '', screenName = '' } = {} } = luxeScreens;
    if (holdStarter) {
      clearTimeout(holdStarter);
    }
    // Otherwise, if the mouse was being held, end the hold
    else if (holdActive) {
      holdActive = false;
      gtmEventPush({
        event: 'product_list_interactions',
        event_category: 'pop_peek',
        event_action: 'pop_peek_used',
        page_type: screenType,
        store_type: 'ajio'
      });

      segmentEventPush({
        event: 'Product Image Long Pressed',
        shared :'',        
        tag_name:'',
        products:[
        {
          ...getProductItemPDP(entity)
        }
        ]
      })

      this.props.similarApiCall(similarProductsVariant, code, name, brandName);
    }
  };
  removeWishlistAlreadyExists = () => {
    const { request = {}, entity = {}, location = {} } = this.props;
    const {
      discountPercent = '',
      price = {},
      fnlColorVariantData: { colorGroup = '' } = {},
      brickCategory = '',
      brickSubCategory = '',
      brickName = ''
    } = entity;
    this.wishListDeleteCall(null, request, colorGroup, price, discountPercent, location, true, brickCategory, brickSubCategory, brickName);
    this.setState({ isWishListed: false });
  };
  removeItemFromLocal = code => {
    const localData = JSON.parse(localStorage.getItem('wishlistPriceDrop')) || [];
    for (let i = 0; i <= localData?.length - 1; i++) {
      if (localData[i]?.itemCode === code) {
        localData?.splice(i, 1);
      }
    }
    localStorage.setItem('wishlistPriceDrop', JSON.stringify(localData));
  };
  wishListDeleteCall = (
    e,
    request,
    code,
    price,
    discountPercent,
    location,
    isRemoveFromProductPage = false,
    brickCategory = '',
    brickSubCategory = '',
    brickName = ''
  ) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    const reqQuery = { ...request.query };
    reqQuery.currentPage = 0;
    const query = buildQuery(reqQuery);
    let nextRequest = { ...request, query };
    this.removeItemFromLocal(code);
    this.removeWishlistInLocal(code);
    if (isRemoveFromProductPage) {
      this.props.removeProductFromWishlistPDP(code, nextRequest);
    } else {
      this.props.removeProductFromWishlist(code, nextRequest);
    }
    this.removeItemCleverTapEvent();
    const { value } = price;
    console.log("TRACK POINT 3 ~ brickCategory:", brickCategory)
    console.log("TRACK POINT 3 ~ brickSubCategory:", brickSubCategory)
    console.log("TRACK POINT 3 ~ brickName:", brickName)
    jioAdsRemoveFromWishList({
      brickCategory,
      brickSubCategory,
      brickName,
      code,
      price: value,
      quantity: 1
    });
    trackRemoveItemFromWishList({ code, price, discountPercent, location });
  };
  handleRemoveItemDialog = (e, request, code, price, discountPercent, location, brickCategory, brickSubCategory, brickName) => {
    const { onDisplayRemoveItemDialog } = this.props;
    onDisplayRemoveItemDialog();
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    this.setState({
      itemArr: [request, code, price, discountPercent, location, brickCategory, brickSubCategory, brickName]
    });
    localStorage.setItem('currentRemoveWishlistProduct', code);
  };
  handleRemoveItem = e => {
    const { onDisplayHideDialog, onRemoveItem } = this.props;
    const {
      luxeStore,
      wishlist: { screenName = '', screenType = '' }
    } = luxeScreens;
    const { itemArr } = this.state;
    console.log("TRACK POINT 3 ~ itemArr:", itemArr)
    let brickCategory = '';
    let brickSubCategory = '';
    let brickName = '';
    if (itemArr.length) {
      this.wishListDeleteCall(e, itemArr[0], itemArr[1], itemArr[2], itemArr[3], itemArr[4], false, itemArr[5], itemArr[6], itemArr[7]);
      onRemoveItem(false);
      onDisplayHideDialog();
      brickCategory = itemArr[5] ?? '';
      brickSubCategory = itemArr[6] ?? '';
      brickName = itemArr[7] ?? ''
    }
    // this.wishListDeleteCall(e, itemArr[0], itemArr[1], itemArr[2], itemArr[3], itemArr[4]);
    this.setState({
      itemArr: []
    });
    gtmEventPush({
      event: 'remove_from_closet',
      event_category: 'wishlist interactions',
      event_actions: 'remove from closet',
      page_type: screenType,
      store_type: luxeStore
    });
    console.log("TRACK POINT 3 ~ brickCategory:", brickCategory)
    console.log("TRACK POINT 3 ~ brickSubCategory:", brickSubCategory)
    console.log("TRACK POINT 3 ~ brickName:", brickName)
    jioAdsRemoveFromWishList({
      brickCategory,
      brickSubCategory,
      brickName,
      code: itemArr[1],
      price: itemArr[2],
      quantity: 1
    });
  };
  handleHideDialog = () => {
    const { onDisplayHideDialog } = this.props;
    // this.setState({
    //   displayRemoveDialog: false,
    //   itemArr: []
    // });
    this.setState(prevState => {
      return {
        itemArr: []
      };
    });
    onDisplayHideDialog();
  };
  renderImage(...imageProperty) {
    const { deviceType = '', pageType } = this.props;
    const { imageURL = '', altTxt = '', productListContainer = '', productTag='' } = imageProperty[0];
    let attributeObj = {
      offsetTop: 500,
      wait: 50,
      src: replaceWithJioCDN(imageURL),
      alt: altTxt
    };
    const renderOverlayText = () => {
      if (productTag && productTag.trim() !== '') {
        const commonStyle = {
          position: 'absolute',
          color: 'white',
          padding: '3px',
          zIndex: 10
        };
  
        const mobileStyle = { 
          ...commonStyle,
          top: '10px',
          left: '10px',
          backgroundColor: 'rgba(0, 0, 0, 1)' ,
          fontSize: '8px',
        };
        const desktopStyle = { 
          ...commonStyle,
          top: '10px',
          left: '10px',
          backgroundColor: 'rgba(0, 0, 0, 1)' ,
          fontSize: '11px',
        };
        const style = deviceType === 'mobile' ? mobileStyle : desktopStyle;
  
        return (
          <div style={style}>
            {productTag.toUpperCase()}
          </div>
        );
      }
      return null;
    };
    
    if (deviceType === 'mobile') {
      attributeObj['onLoad'] = () => {
        let { sizeInfo = {}, cacheInvalid } = this.props;
        const { heightOffset = 0 } = sizeInfo;
        const { height = 100 } = elementSize(productListContainer);
        height > oldHeight && ((cacheInvalid = true), (oldHeight = height));
        if (cacheInvalid && productListContainer) {
          // const { height = 100 } = elementSize(productListContainer);
          if (pageType == 'pdp') {
            this.props.setGridConfigPDP({
              gridRowHeight: height + heightOffset + 18,
              cacheInvalid: false
            });
          }
          else {
            this.props.setGridConfig({
              gridRowHeight: height + heightOffset + 18,
              cacheInvalid: false
            });
          }
        }
      };
    }
    else {
      attributeObj['onLoad'] = () => {
        let { sizeInfo = {}, cacheInvalid } = this.props;
        const { heightOffset = 0 } = sizeInfo;
        const { height = 100 } = elementSize(productListContainer);
        height > oldHeight && ((cacheInvalid = true), (oldHeight = height));
        if (cacheInvalid && productListContainer) {
          if (pageType !== 'pdp') {
            this.props.setGridConfig({
              gridRowHeight: height + heightOffset,
              cacheInvalid: false
            });
          }
        }
      };
    }
    const { isAboveFold = false } = this.props;
    if (isAboveFold) {
      return (
        <div>
          {renderOverlayText()}
          <img
            src={attributeObj.src}
            alt={attributeObj.alt}
            loading="eager"
            fetchpriority="high"
            decoding="sync"
            onLoad={attributeObj.onLoad}
            width="100%"
            height="auto"
            style={{ display: 'block', aspectRatio: '4/5' }}
            className="rilrtl-lazy-img-loaded"
          />
        </div>
      );
    }
    return (
      <div>
        {renderOverlayText()}
        <LazyImage {...attributeObj} />
      </div>
    );
  }
  // renderImage(...imageProperty) {
  //   const { deviceType = '', pageType } = this.props;
  //   const { imageURL = '', altTxt = '', productListContainer = '' } = imageProperty[0];
  //   let attributeObj = {
  //     offsetTop: 500,
  //     wait: 50,
  //     src: `${imageURL}`,
  //     alt: altTxt
  //   };
  //   if (deviceType === 'mobile') {
  //     attributeObj['onLoad'] = () => {
  //       let { sizeInfo = {}, cacheInvalid } = this.props;
  //       const { heightOffset = 0 } = sizeInfo;
  //       const { height = 100 } = elementSize(productListContainer);
  //       height > oldHeight && ((cacheInvalid = true), (oldHeight = height));
  //       if (cacheInvalid && productListContainer) {
  //         // const { height = 100 } = elementSize(productListContainer);
  //         if(pageType == 'pdp'){
  //           this.props.setGridConfigPDP({
  //             gridRowHeight: height + heightOffset + 18,
  //             cacheInvalid: false
  //           });
  //         }
  //         else {
  //         this.props.setGridConfig({
  //           gridRowHeight: height + heightOffset + 18,
  //           cacheInvalid: false
  //         });
  //         }     
  //       }
  //     };
  //   }
  //   else{
  //     attributeObj['onLoad'] = () => {
  //       let { sizeInfo = {}, cacheInvalid } = this.props;
  //       const { heightOffset = 0 } = sizeInfo;
  //       const { height = 100 } = elementSize(productListContainer);
  //       height > oldHeight && ((cacheInvalid = true), (oldHeight = height));
  //       if (cacheInvalid && productListContainer) {
  //         if(pageType !== 'pdp'){
  //           this.props.setGridConfig({
  //             gridRowHeight: height + heightOffset,
  //             cacheInvalid: false
  //           });
  //         } 
  //       }
  //     };
  //   }
  //   return <LazyImage {...attributeObj} />;
  // }
  inViewOnChangeHandler = ({ isInView, productId }) => {
    const { pageUrl, newDesignLuxe } = this.props;
    const productImpressions = JSON.parse(sessionStorage?.getItem(`${pageUrl}`)) || [];
    const impressionTriggeredForCurrent = productImpressions.indexOf(productId) === -1 ? false : true;
    if (isInView && !impressionTriggeredForCurrent && !newDesignLuxe) {
      this.props.triggerIfProductIsOnView({ productId })
    }
  }
  render() {
    const {
      entity = {},
      style = {},
      location = {},
      productToggle = '',
      pageTitle = '',
      productSizeDetails = '',
      position = -1,
      plpSizesFlag,
      productsAdditionalInfo = {},
      newSizeRevampFlag,
      showBrandSizeFlag,
      luxeFlags,
      currentStore,
      flags,
      priceRevealMetaInfo = {},
      store = 'AJIO',
      onRemoveItem,
      newDesignLuxe,
      onClickProduct,
      offerPriceShow,
      isOldView,
      showPlpExtendedBanner,
      gridColumns,
      isEarlyAccessUser = false,
      showSimiliarProductFlag,
      changeView,
      toggleView,
      jioAds = {},
      enableRating,
      enableRatingLabelPLP,
      enableRatingLabelWishlist,
      storesForHidingMRP,
      freeTextSearch,
      sourcePage,
      jioAdsSource,
      enableGiftWithProduct,
      giftWithProductConfig,
      isComingSoonEnabled,
      previousSource,
      priorityDeliveryConfig,
      enablePriorityDeliveryPhase2 = false,
      priorityDeliverySLPTagsConfig = {},
      ajiogramInterventionsConfig,
      urgencyDriverV2PLPEnable = false,
      enableRushDelivery = false,
      osmosClientId,
      isAboveFold = true,
      enablePlpLcpV2 = true,
      enablePlpInpV1 = true
    } = this.props;
  
    const { PLP_BUCKET = {} } = priorityDeliverySLPTagsConfig;
    const enable_perf_changes = true;
    const {plpConfig:{ tagContent: {logo = '', text = '', backgroundColor = '', textColor = ''} = {}, enableIntervention = false} = {}}= ajiogramInterventionsConfig;
    let fleek = String(store).toLowerCase() === FLEEK_STORE.toLowerCase();
    let fleekForBBS = String(this.props.store).toLowerCase() === FLEEK_STORE.toLowerCase();
    if (this.props.pageType === 'wishlist') {
      fleek = false;
    }
    if (this.state.itemArr.length) {
      {
        onRemoveItem && this.handleRemoveItem();
      }
    }
    const query = queryUtil.parseSearch(location.search);
    let { viewType } = query;
    let {
      name = '',
      code,
      url,
      images = [],
      catalogName = '',
      discountPercent = '',
      altText = '',
      price = {},
      wasPriceData = {},
      fnlColorVariantData = {},
      offerPrice = {},
      isComingSoonProduct,
      isGiftWithPurchase = false,
      variantOptions = [],
      couponStatus = this.couponApplicableText,
      productSizeData = {},
      exclusiveTill: exclusiveWishlist = '',
      tags: { categoryTags = [] } = {},
      urgencyDriverTagResponse: { positions = [] } = {}
    } = entity;
    const enablePlpIntervention = enableIntervention && String(store).toLowerCase() === 'ajio' &&  String(catalogName).toLowerCase() === 'ajiogram'
    const { deviceType = '', request = {}, requestPDP = {} } = this.props;
    const { displayformattedValue: finalPrice = '', value: sp = 0, futureBestPrice = '' } = price;
    const { displayformattedValue: orginalPrice = '' } = wasPriceData;
    const { deliverySlaTag = '', deliveryMethod = '' } = fnlColorVariantData;
    const {
      brandName = '',
      outfitPictureURL,
      exclusiveTill: exclusiveValue = '',
      productTag = '',
      allPromotions,
      colorGroup = code
    } = fnlColorVariantData;
    const exclusiveTill = exclusiveValue || exclusiveWishlist;
    let productTagValue = productTag;

    if (
      productTagValue?.toLowerCase() === 'coming soon' &&
      !(isComingSoonEnabled && isComingSoonProduct)
    ) {
      productTagValue = '';
    } else if (
      !(isComingSoonEnabled && isComingSoonProduct) &&
      isExclusiveDatePast(exclusiveTill)
    ) {
      productTagValue = 'EXCLUSIVE';
    }
  
    const PLPTagV2TopLeft = getPLPTagV2FromPosition(positions, 'PRODUCT_TILE_IMAGE_TOP_LEFT')
    const newProductTagEngineValue =
      deviceType == 'mobile' &&
      pageType !== 'wishlist' &&
      urgencyDriverV2PLPEnable &&
      PLPTagV2TopLeft?.shortText;
    const productTagEngineValue = newProductTagEngineValue || getTagValueFromTagEngine(categoryTags);
    const productPriceLabel = getPriceLableFromTagEngine(categoryTags);
    const { displayformattedValue = '', priceReveal = {}, value: offerValue = '', giftAvailable = false } = offerPrice;
    let { sizeVariants = [] } = productSizeData;
    let priceRevealState = getPriceRevealSaleDuration(
      flags,
      deviceType,
      priceRevealMetaInfo,
      store
    );
    if (fleekForBBS) {
      priceRevealState = null
    }
    let more = sizeVariants && sizeVariants.length > 4 ? sizeVariants.length - 4 : '';
    if (sizeVariants && sizeVariants.length > 4) {
      sizeVariants = sizeVariants.slice(0, 4);
    }
    let imageURL, sizeName;
    let arr = [];
    let { location: { href = '' } = {} } = window;
    const {
      showSizePopup = false,
      variantOptions: stateSizeVariantOptions,
      sizeDisplayType = '',
      itemArr,
      displayRemoveDialog
    } = this.state;
    if (deviceType === 'mobile') {
      imageURL = images.reduce((imageurl, currentElm) => {
        let { format = '', url = '' } = currentElm;
        if (format === 'mobileProductListingImage') {
          imageurl = url;
        }
        return imageurl;
      }, '');
    }
    let priceSectionClass = '';
    if (deviceType == 'mobile') {
      priceSectionClass += 'price-details ';
    }
    if (couponStatus == this.couponNotApplicableText) {
      priceSectionClass += 'no-coupon-applicable';
    }
    if (!imageURL) {
      imageURL = images[0] ? images[0].url : '#';
    }
    if (!discountPercent) {
      let sp = price.value;
      let cp = wasPriceData.value;
      let discount;
      if (sp !== cp) {
        discount = Math.round(((cp - sp) / cp) * 100);
        discountPercent = `${discount}% off`;
      }
    }
    let altTxt = images[0] ? images[0].altText : '';
    if (viewType == null || viewType == undefined) {
      // if (productToggle) {
      //   if (productToggle == "TOGGLE_ON_PRODUCT") viewType = "productview";
      // } else {
      viewType = 'outfitview';
      // }
    }
    // if (viewType === "productview" && outfitPictureURL) {
    //   imageURL = outfitPictureURL;
    // }
    const filterBySize = size => {
      let flag = false;
      if (size.qualifier === 'size' && !flag) {
        sizeName = size.value;
      } else {
        if (size.qualifier === 'standardSize' && size.value) {
          sizeName = size.value;
          flag = true;
        }
      }
    };
    variantOptions.forEach((size, i) => {
      const { stock = {}, variantOptionQualifiers = [] } = size;
      const { stockLevelStatus, stockLevel } = stock;
      const filteredSize = variantOptionQualifiers.filter(filterBySize);
      const { Size = '', sizeType = '' } = fetchSizeAndBrandSize(
        variantOptionQualifiers,
        newSizeRevampFlag
      );
      if (stockLevel > 0) {
        arr.push(Size || sizeName);
      }
    });
    let sizeDetails = arr.join(' ');
    if (arr.length > 3) {
      sizeDetails = arr.slice(0, 3).join(' ') + ' +MORE';
    }
    // DEAL OF THE DAY
    const { dealStartTime = '', dealEndTime = '' } = productsAdditionalInfo;
    const isCurated = dealStartTime && dealEndTime ? true : false;
    // const { isDealStart = false } = dealStartTime && IsDealStart(dealStartTime);
    // const { isDealEnd = true } = dealEndTime && IsDealEnd(dealEndTime);
    // if Curated Page
    // const setDodCssForPriceForCurated = isDealStart && !isDealEnd && isCurated ? 'green-price' : '';
    // const dealOfDayDomForCurated = isDealStart && !isDealEnd && isCurated ? (
    //   <div className="dealOfDay">
    //     {<DealOfTheDayTag />}
    //     {<DealOfTheDayTimerTag imagePath={"/static/img/endsIn.png"} dealOfTheDayProductTimer={dealEndTime} />}
    //   </div>
    // ) : (
    //   ''
    // );
    // if not curated
    const {
      isDODEnabled = false,
      dodPriceData = {},
      dodDiscountPercent = '',
      dodQuantityLeft = '',
      dodEndTime = '',
      catalog
    } = entity;
    const {
      currencyIso: dodCurrencyIso = '',
      formattedValue: dodFormattedValue = '',
      displayformattedValue: dodDisplayFormattedValue = '',
      value: dodValue = ''
    } = dodPriceData;
    const setDodCssForPrice = isDODEnabled ? 'green-price' : '';
    const fleekPrice = fleek ? 'fleek-price' : ''
    const dodFinalPrice = isDODEnabled ? dodValue : finalPrice;
    // const dealOfDayDom = isDODEnabled && <Suspense fallback={<div></div>} >
    //   <DodTimer dodEndTime={dodEndTime}/>
    // </Suspense>;
    const dealOfDayDom = isDODEnabled && (
      <DodTimer dodEndTime={dodEndTime} deviceType={deviceType} />
    );
    const nameCls = name.length > 28 ? 'name' : 'name-center';
    const { isThemeEnable } = luxeFlags;
    const luxe = isThemeEnable === 'ON' && currentStore === 'luxe';
    const { id, displayRatingWidget } = this.props;
    const {
      price: { formattedValue: formattedSp = '' } = {},
      wasPriceData: { value: mp = 0, formattedValue: formattedMp = '' } = {},
      brickCategory,
      brickSubCategory,
      brickName,
      sourceStoreId,
      adsData,
      averageRating,
      numUserRatings,
      ratingCount,
      segmentId = '',
      experimentId = ''
    } = entity;
    const { pageType, rowIndex, columnIndex, plpUnratedProdWidgetPosition, wishlistUnratedProdWidgetPosition, displayWidgetShimmer, unratedItems = [], listingAds = false, isJioAd = false } = this.props;
    const tag = exclusiveTill ? 'Exclusive' : '';
    const { screenName = '', screenType = '' } = luxeScreens[pageType] || {};
    const pageName =
      screenName === 'landing screen' || screenName === 'plp screen' ? '' : screenName;
    const { luxeStore, defaultStore } = luxeScreens;
    const { value } = price;
    const color = pageType === 'plp' ? colorGroup?.split('_')?.[1] : id.split('_')[1];
    const productId = pageType === 'plp' ? colorGroup?.split('_')?.[0] : id.split('_')[0];
    const productUrl = properties.getProperty(sourceStoreId === 'street' ? 'streetURL' : (sourceStoreId === "luxe" ? 'luxeURL' : sourceStoreId === 'ajiogram' ? 'fleekURL' : 'parentUrl')) + addCustomerType(url)
    const { pdpList: { youMayAlsoLikeList = '' } } = luxeList;
    const imageBaseUrl = properties.getProperty("imageBaseUrl");
    const adText = 'AD';
    const { ad = '' } = adsData || {};
    const showAd = !luxe ? !!ad : false;
    let catalogueOfProduct = catalogName != '' ? catalogName : catalog
    const hideMRP = isCatalogNameInFirebaseStore(storesForHidingMRP, catalogueOfProduct)
    let styleUpdated = { ...style };
    if (rowIndex === plpUnratedProdWidgetPosition + 2 && pageType === 'plp' && displayRatingWidget && style && style.top && style.height) {
      styleUpdated = { ...styleUpdated, top: isJioAd ? deviceType === 'mobile' ? styleUpdated.top - 130 : styleUpdated.top - 250 : listingAds ? styleUpdated.top - 100 : styleUpdated.top - 70 }
    }
    if (rowIndex > plpUnratedProdWidgetPosition + 2 && pageType === 'plp' && displayRatingWidget && style && style.top && style.height) {
      styleUpdated = { ...styleUpdated, top: isJioAd ? deviceType === 'mobile' ? styleUpdated.top - 150 : styleUpdated.top - 250 : listingAds ? styleUpdated.top - 100 : styleUpdated.top - 80 }
    }
    if (rowIndex >= wishlistUnratedProdWidgetPosition + 2 && pageType === 'wishlist' && displayRatingWidget && style && style.top && style.height) {
      styleUpdated = { ...styleUpdated, height: styleUpdated.height - 100, top: styleUpdated.top - 250 }
    }
    if (((rowIndex === plpUnratedProdWidgetPosition + 1 && pageType === 'plp') || (rowIndex === wishlistUnratedProdWidgetPosition + 1 && pageType === 'wishlist')) && style && style.top && style.height && displayRatingWidget) {
      styleUpdated.top -= styleUpdated.height - (253 + 14 + 10);
    }
    let ratingWidgetTop = isJioAd ? 0 : pageType === 'wishlist' ? -30 : 14;
    let gwpDimension = '';
    if (!fleek && enableGiftWithProduct) {
      if (pageType === 'wishlist' && isGiftWithPurchase) {
        gwpDimension = 'GetFreebies';
      } else if (giftAvailable) {
        gwpDimension = 'GetFreebies';
      }
    }  
    return (
      ((rowIndex === plpUnratedProdWidgetPosition && pageType === 'plp') || (rowIndex === wishlistUnratedProdWidgetPosition && pageType === 'wishlist')) && displayRatingWidget ?
        columnIndex === 0 ? null :
          (displayWidgetShimmer ? <LoadingHomeRate topPart={style.top + 14} positionPart='absolute' /> :
            unratedItems.length > 0 ? <Suspense fallback={null}><PlpRatingWidget pageType={pageType === 'plp' ? 'LP' : 'Wishlist'} topPart={styleUpdated.top + ratingWidgetTop} widthPart='100%' heightPart='215px' bgPart='#f0f4f7' positionPart='absolute' /></Suspense> : null
          )
        :
        <div
          className={
            pageType === "pdp" && !isOldView ? 'item rilrtl-you-may-like-products-list__item item' : luxe ? (changeView && pageType === "plp") ? 'item rilrtl-luxe-products-list__item item listView' : 'item rilrtl-luxe-products-list__item item'
              : pageType === "plp" && (showSimiliarProductFlag && !pageTitle && similarProductsVariant == 3) ? 'item rilrtl-products-list__item item disable-right-click' : changeView ? 'item rilrtl-products-list__item item listView' : fleek ? 'item rilrtl-products-list__item item fleek-bg' : 'item rilrtl-products-list__item item'
          }
          role="row"
          style={styleUpdated}
          onMouseLeave={this.mouseLeaveHandler}
        >
          {deviceType === 'mobile' ? (
            <div role="gridcell" id={`product-${rowIndex}`}>
              <a
                className={'rilrtl-products-list__link'}
                key={code}
                href={
                  pageType === 'wishlist'
                    ? productUrl
                    : `${addCustomerType(url)}${addCustomerType(url).includes('?') ? '&' : '?'}${isCopilotReferrer() ? 'plp_source_details=ai_assistant_widget' : ''}`
                }
                onClick={() => {
                  const fromVideoBanner = redirectedFromVideoBanner();
                  if (pageType === 'plp') {
                    let scrollPosition = window.scrollY || 0;
                    createCookie('mobilePLPScrollPosition', scrollPosition);
                  }
                  if (luxe || pageType === 'pdp') {
                    const isExternalLink = isMarketing(window.location.href);
                    if (isExternalLink && !luxe) {
                      sessionStorage.setItem('exitIntent', 'true');
                    }
                    let offerName = gwpDimension;
                    if (!fleek && (enableRushDelivery || enablePriorityDeliveryPhase2)) {
                      offerName = offerName
                        ? `${offerName}, ${PLP_BUCKET[`${deliverySlaTag}`]}`
                        : PLP_BUCKET[`${deliverySlaTag}`];
                    }
                    let itm_source_detail = '';
                    if(isCopilotReferrer()){
                      itm_source_detail = 'ai_assistant_widget'
                    }
                    luxeGtmProductClick({
                      name,
                      id: productId,
                      price: value,
                      wasProductPrice: mp,
                      brand: brandName,
                      position: position,
                      category: brickCategory || '',
                      product_size: sizeDetails,
                      product_color: color,
                      product_trade_discount: discountPercent,
                      product_brick: isNaN(brickName) ? brickName : '',
                      product_tag: newProductTagEngineValue || tag,
                      list: this.state.fromFloatingWidget ? 'video floating widget banner plp' : fromVideoBanner ? 'video banner plp' : pageType === 'pdp' ? youMayAlsoLikeList : screenName,
                      store_type: currentStore,
                      pageType: screenType,
                      pageName: screenName,
                      showPlpExtendedBanner: showPlpExtendedBanner && !priceRevealState,
                      productTagEngineValue: pageType !== 'wishlist' && getVariant('enable_urgency_driver_plp') ? productTagEngineValue : productTag,
                      productPriceLabel: pageType !== 'wishlist' && getVariant('enable_urgency_driver_plp') ? productPriceLabel : '',
                      plpViewType: pageType !== 'wishlist' && toggleView ? toggleView == 1 ? 'list' : 'grid' : '',
                      catalog: catalogueOfProduct,
                      segmentId: segmentId,
                      experimentId: experimentId,
                      sourcePage,
                      jioAdsSource,
                      offerName,
                      itm_source_detail,
                      adsData,
                      code,
                      skuId: variantOptions?.[0]?.code || code || ''
                    });
                  } else {
                    if (onClickProduct) onClickProduct();
                    const {plpConfig:{ tagContent: {logo = '', text = '', backgroundColor = '', textColor = ''} = {}, enableIntervention = false} = {}}= ajiogramInterventionsConfig;
                    const enablePlpIntervention = enableIntervention && String(store).toLowerCase() === 'ajio' &&  String(catalogName).toLowerCase() === 'ajiogram'
                    trackProductItemClick({
                      position,
                      code,
                      price,
                      discountPercent,
                      location,
                      entity,
                      showPlpExtendedBanner: showPlpExtendedBanner && !priceRevealState,
                      pageTypeCard: pageType,
                      fromVideoBanner,
                      toggleView,
                      fromFloatingWidget: this.state.fromFloatingWidget,
                      averageRating,
                      ratingCount: pageType === 'wishlist' ? numUserRatings : ratingCount,
                      freeTextSearch,
                      sourcePage,
                      jioAdsSource,
                      gwpDimension,
                      isComingSoonProduct: isComingSoonProduct,
                      previousSource,
                      enablePriorityDeliveryPhase2,
                      enableRushDelivery,
                      deliveryDateAndTimeTag: PLP_BUCKET[`${deliverySlaTag}`],
                      enablePlpIntervention,
                      interventionText: text,
                      newProductTagEngineValue,
                      osmosClientId
                    });
                  }
                }}
                onTouchStart={showSimiliarProductFlag && !pageTitle && similarProductsVariant == 3 && !luxe ? this.onTouchStart : () => { }}
                onTouchEnd={(e) => showSimiliarProductFlag && !pageTitle && similarProductsVariant == 3 && !luxe ? this.onTouchEnd(e, code, name, brandName, entity) : () => { }}
                aria-labelledby={`product-brand-${code} product-title-${code} price-section-${code} rating-value-container-${code} current-offer-price-${code}`}
              >
                <div
                  className="preview"
                  ref={productListContainer => {
                    this.productListContainer = productListContainer;
                  }}
                >
                  <div id={`imgHolder-${code}`} data-code={code} style={{backgroundImage: `url(${`${imageBaseUrl}/static/img/plp.png`})`}} className={`${changeView ? '' : luxe ? 'luxeImgHolder' : fleek ? 'imgHolder fleek-img-holder' : 'imgHolder'} ${enablePlpIntervention ? 'margin0' : ''}`}>
                    {!changeView ? <><InView as="div" className={`${code}`} threshold={0.5} triggerOnce={true} onChange={(inView, entry) => this.inViewOnChangeHandler({ isInView: inView, productId: code })}>
                      {isComingSoonEnabled ? this.renderImage({
                        imageURL,
                        altTxt: `Product image of ${brandName} ${name}`,
                        productListContainer: this.productListContainer,
                        productTag: productTagValue
                      })  : this.renderImage({
                        imageURL,
                        altTxt: `Product image of ${brandName} ${name}`,
                        productListContainer: this.productListContainer,
                      })
                    }
                     </InView>
                     </>
                      :
                     <> <InView as="div" key={`${code}`} className={`${code}`} threshold={0.5} triggerOnce={true} onChange={(inView, entry) => this.inViewOnChangeHandler({ isInView: inView, productId: code })}>
                        <div className={cx('viewType')}>
                          <Suspense fallback={<div>Loading...</div>}>
                            <ProductScroller
                              luxe={!changeView && luxe}
                              images={this.state.imagesForScroller}
                              onProductImageClick={() => { }}
                              hasSimilarStyles={false}
                              isPDPScroll={true}
                              productUrl={""}
                              addToWishlistApi={() => { }}
                              productLiked={false}
                              parentProduct={entity}
                            />
                          </Suspense>
                        </div>
                      </InView>
                    
                      </>
                    }
                    {!sizeDetails && pageTitle && (
                      <div
                        className={luxe ? 'luxe-rilrtl-out-of-stock' : 'rilrtl-out-of-stock'}
                        style={isComingSoonEnabled && isComingSoonProduct ? { backgroundColor: 'transparent' } : {}}
                      >
                        {(!isComingSoonProduct || !isComingSoonEnabled) && (
                          <span aria-label={luxe ? 'out of stock' : ''}>{luxe ? 'out of stock' : ''}</span>
                        )}
                      </div>
                    )}
                    {!isComingSoonEnabled && (productTagValue || productTagEngineValue) && !showAd ? (
                      (pageType === 'wishlist' || !getVariant('enable_urgency_driver_plp')) ?
                        productTagValue && <div className={luxe ? 'luxe-exclusive' : 'exclusive'} aria-label={productTagValue}>{productTagValue}</div>
                        :
                        getVariant('enable_urgency_driver_plp') && productTagEngineValue &&
                        <div className={luxe ? 'luxe-exclusive' : 'exclusive-new'}>{productTagEngineValue}</div>
                    ) : null}
              
                    {showAd ? <div className={fleek ? 'adDisplay fleek-ad' : 'adDisplay'}>{adText}</div> : null}
                    {showSimiliarProductFlag && !pageTitle && (similarProductsVariant == 1 || similarProductsVariant == 2) && !luxe ?
                      <div className={!changeView ? 'similarStylesContainer' : 'similarStylesContainer similarinListView'}>
                        {similarProductsVariant == 1 &&
                          <div
                            className="similarStylesWithIcon"
                            style={{ background: luxe ? 'transparent' : '#fff' }}
                          >
                            <Button
                              id="plp_similar_icon"
                              ariaLabel="similar styles"
                              variant="circular"
                              size="xs"
                              icon="icon-Similar"
                              diameter={24}
                              iconStyles={{
                                fontSize: '2.4rem',
                                color: "#202020"
                              }}
                              onClick={(e) => {
                                gtmEventPush({
                                  event: 'product_list_interactions',
                                  event_category: 'product list interactions',
                                  event_action: 'similar to click',
                                  label: 'icon',
                                  page_name: screenName,
                                  page_type: screenType,
                                  store_type: 'ajio'
                                });
                                segmentEventPush({
                                  event: 'Similar Item Icon Clicked On PLP',
                                  screen_name: screenName,
                                  screen_source: screenType,
                                  products:[
                                    {
                                      ...getProductItemPDP(this.props?.entity)
                                    }
                                  ]
                                });

                                this.fetchSimiliarStylesApiCall(e, code, name, brandName);
                              }}>
                            </Button>
                          </div>
                        }
                        {similarProductsVariant == 2 &&
                          <div
                            className={fleek ? 'similarStylesWithButton similar-style-fleek-button' : 'similarStylesWithButton'}
                            style={{ background: luxe ? 'transparent' : !fleek ? '#fff' : '' }}
                            onClick={(e) => {
                              gtmEventPush({
                                event: 'product_list_interactions',
                                event_category: 'product list interactions',
                                event_action: 'similar to click',
                                label: 'text',
                                page_name: screenName,
                                page_type: screenType,
                                store_type: 'ajio'
                              });
                               segmentEventPush({
                                  event: 'Similar Item Icon Clicked On PLP',
                                  screen_name: screenName,
                                  screen_source: screenType,
                                  products:[
                                    {
                                        ...getProductItemPDP(this.props?.entity)
                                    }
                                  ]
                                 

                                });
                                

                              this.fetchSimiliarStylesApiCall(e, code, name, brandName)
                            }
                            }
                          >
                            <span className="viewSimilarText">VIEW SIMILAR</span>
                          </div>
                        }
                      </div>
                      : <></>
                    }
                    {allPromotions ? <div className="sec-prod-offer" /> : null}
                    {enablePlpIntervention && <div className='intervention-tag' style={{backgroundColor: backgroundColor}}> <img src={logo} alt='ajiogram tag' /><div style={{color: textColor}} className={cx('text')}>{text}</div></div> }
                  </div>
                  
                  <div className={luxe ? changeView ? 'luxeContentHolder content' : 'luxeContentHolder' : changeView ? 'contentHolder content' : fleek ? 'contentHolder fleek-text-primary' : 'contentHolder'}>
                    <div className={fleek ? 'brand fleek-text-primary' : "brand"} id={`product-brand-${code}`} aria-hidden="true"><strong>{brandName.toUpperCase()}</strong></div>
                    <div className={`${nameCls} ${fleek && 'fleek-text-secondary'}`} id={`product-title-${code}`} aria-hidden="true">{name}</div>
                    {((getFeatureVariant('rating-label-display-msite-wishlist') !== '0' && pageType === 'wishlist' && enableRatingLabelWishlist) ||
                      (getFeatureVariant('rating-label-display-msite-plp') !== '0' && pageType !== 'wishlist' && enableRatingLabelPLP)) &&
                      (
                        enableRating && averageRating && !luxe &&
                        <AggregatedRatingTag
                          fleek={fleek}
                          ratingValue={averageRating}
                          totalRatingCount={pageType === 'wishlist' ? numUserRatings : ratingCount}
                          customClass={"rating-label-msite-cart"}
                          backGroundColour={averageRating < 3 ? 'red' : fleek ? 'fleek-green' : 'green'} 
                          code={code}
                        />
                      )
                    }
                    <div
                      id={`price-section-${code}`}
                      aria-labelledby={`price-value-${code} current-actual-price-${code} `}
                      aria-hidden="true"
                      className={priceSectionClass}
                      style={
                        !fleek && enableGiftWithProduct
                          ? ((pageType === 'wishlist' ? isGiftWithPurchase : giftAvailable) && {
                            marginBottom: '3px'
                          }) ||
                          {}
                          : {}
                      }
                    >
                      <strong>
                        <span 
                          id={`price-value-${code}`}
                          className={`price ${setDodCssForPrice} ${fleekPrice}`}
                          aria-label={orginalPrice == finalPrice ? `Price ${finalPrice}.` : `Discount Price is ${finalPrice}`}
                          aria-hidden="true"
                        >
                          {Constant.AW_RUPEE_SYMBOL}
                          <span id="price-value">{`${formatPrice(finalPrice).replace('.00', '')}`}</span>
                        </span>
                      </strong>
                      {isDODEnabled && !luxe ? (
                        <>
                          {hideMRP &&
                            <div 
                              className="offer-price"
                              aria-label={`MRP ${Constant.AW_RUPEE_SYMBOL}
                                ${orginalPrice !== finalPrice && getPriceStripped(orginalPrice).replace('.00', '')}. 
                                ${isDODEnabled
                                ? ` ${dodDiscountPercent}`
                                : parseInt(discountPercent) > 0
                                  ? ` ${discountPercent}`
                                  : ''} Off`
                                }
                            >
                              <span className={fleek ? 'orginal-price fleek-original-price' : 'orginal-price'} >
                                {Constant.AW_RUPEE_SYMBOL}
                                {orginalPrice !== finalPrice &&
                                  getPriceStripped(orginalPrice).replace('.00', '')}
                              </span>
                              <strong>
                                <span className={fleek ? 'discount fleek-discount' : 'discount'} >
                                  {' '}
                                  {isDODEnabled
                                    ? `${dodDiscountPercent}`
                                    : parseInt(discountPercent) > 0
                                      ? `${discountPercent}`
                                      : ''}
                                </span>
                              </strong>
                            </div>
                          }
                          <div className="showDealPricePLP" aria-label={`Deal price : ${displayValue(dodFinalPrice)}`}>
                            Deal price : {displayValue(dodFinalPrice)}
                          </div>
                        </>
                      ) : orginalPrice == finalPrice ? null : (
                        hideMRP &&
                        <div 
                          id={`current-actual-price-${code}`}
                          // id={`actual-price-${code}`}
                          className="offer-price"
                          aria-label={`and Actual Price is ${orginalPrice}. ${isDODEnabled
                            ? `${dodDiscountPercent}`
                            : parseInt(discountPercent) > 0
                              ? `${discountPercent}`
                              : ''}`}
                          aria-hidden="true"
                          >
                          <span className={fleek ? 'orginal-price fleek-original-price' : "orginal-price"} >
                            {Constant.AW_RUPEE_SYMBOL}
                            {getPriceStripped(orginalPrice).replace('.00', '')}
                          </span>
                          <strong>
                            <span className={fleek ? 'discount fleek-discount' : 'discount'} >
                              {' '}
                              {isDODEnabled
                                ? `${dodDiscountPercent}`
                                : parseInt(discountPercent) > 0
                                  ? `${discountPercent}`
                                  : ''}
                            </span>
                          </strong>
                        </div>
                      )}
                    </div>
                    {!priceRevealState && offerPrice.displayformattedValue && pageTitle != 'Wishlist' && !luxe && sp !== offerValue ?
                      <Feature featureName="enable_urgency_driver_plp">
                        <Variant id="0">
                          {
                            offerPriceShow ? (
                              <div className="offer-div-new" id={`current-offer-price-${code}`} aria-hidden="true" aria-label={`Offer Price is ${displayformattedValue}`}>
                                <img src={`${imageBaseUrl}/static/img/percentage.svg`} alt="offer icon" className='offer-icon' />
                                <span className={fleek ? 'fleek-offer-new offer-new' : 'offer-new'}>Offer price</span>&nbsp;
                                <span className={fleek ? 'offer-pricess-new fleek-offer-pricess-new' : 'offer-pricess-new'}>
                                  {Constant.AW_RUPEE_SYMBOL}
                                  {formatPrice(displayformattedValue)}
                                </span>
                              </div>
                            ) :
                              <div className={fleek ? 'offer-div fleek-offer-div' : 'offer-div'}>
                                <strong>
                                  <span className="offer" aria-label="Offer Price:" style={fleek ? { color: '#34E15D' } : {}}>Offer Price:</span>&nbsp;&nbsp;
                                  <span className={fleek ? 'fleek-offer-pricess' : 'offer-pricess'} aria-label={`₹${formatPrice(displayformattedValue)}`}>
                                    {Constant.AW_RUPEE_SYMBOL}
                                    {formatPrice(displayformattedValue)}
                                  </span>
                                </strong>
                              </div>
                          }
                        </Variant>
                        <Variant id="1">
                          <div className="offer-div-new" id={`current-offer-price-${code}`} aria-hidden="true" aria-label={`${productPriceLabel ? productPriceLabel : 'Offer Price'} is ₹${displayformattedValue}`} >
                            <img src={`${imageBaseUrl}/static/img/percentage.svg`} alt="offer icon" className='offer-icon' />
                            <span className={fleek ? 'fleek-offer-new offer-new' : 'offer-new'}>{productPriceLabel ? productPriceLabel : 'Offer Price:'}</span>&nbsp;
                            <span className={fleek ? 'offer-pricess-new fleek-offer-pricess-new' : 'offer-pricess-new'}>
                              {Constant.AW_RUPEE_SYMBOL}
                              {formatPrice(displayformattedValue)}
                            </span>
                          </div>
                        </Variant>
                      </Feature>
                      : <></>}
                    {/* MSITE  */}
                    {!fleek && enableGiftWithProduct &&
                      (pageType === 'wishlist' ? isGiftWithPurchase : giftAvailable) && (
                        <div className={luxe ? "gwp-container-luxe" : "gwp-container"}>
                          <img
                            className="gwp-icon"
                            alt="Gift Wrap Icon"
                            src={`${imageBaseUrl}/static/img/${luxe ? 'GWP-luxe-plp.svg' : 'GWP.svg'
                              }`}
                          />
                          <span className={luxe ? 'gwp-text-luxe' : 'gwp-text'}>
                            {giftWithProductConfig.productWidgetTitle}
                          </span>
                        </div>
                      )}
                    {!luxe && dealOfDayDom}
                    {!isDODEnabled && priceRevealState && (
                      <PriceRevealPLP
                        priceReveal={priceReveal}
                        orignalPrice={sp}
                        offerValue={offerValue}
                        futureBestPrice={futureBestPrice}
                        luxe={luxe}
                        hasLineBreak={luxe ? true : false}
                        isEarlyAccessUser={isEarlyAccessUser}
                      />
                    )}
                    {plpSizesFlag &&
                      !luxe &&
                      (newDesignLuxe ? '' : <ShowSizeDetail sizeVariants={sizeVariants} more={more} fleek={fleek} />)}
                    {pageTitle && luxe && !sizeDetails && !isComingSoonProduct ? (
                      <div
                        className={
                          luxe ? 'luxe-wishlist_remove luxe-delete' : 'luxe-wishlist_remove delete'
                        }
                        onClick={e =>
                          this.wishListDeleteCall(e, request, code, price, discountPercent, location, false, brickCategory, brickSubCategory, brickName)
                        }
                        role="button"
                        tabIndex={0}
                      >
                        <Icon
                          ariaLabel='luxe delete'
                          icon="luxe-Delete"
                          iconClass="luxe-wishlist-remove-icon"
                          styles={{ color: '#070707' }}
                        />
                        <span aria-label='REMOVE'>REMOVE</span>
                      </div>
                    ) : pageTitle ? (
                      <div className="button-container">
                        <div
                          // id="wishlist_delete"
                          className={luxe ? 'luxe-delete' : 'delete'}
                          onClick={e =>
                            luxe
                              ? this.handleRemoveItemDialog(
                                e,
                                request,
                                code,
                                price,
                                discountPercent,
                                location,
                                brickCategory,
                                brickSubCategory,
                                brickName
                              )
                              : this.wishListDeleteCall(
                                e,
                                request,
                                code,
                                price,
                                discountPercent,
                                location,
                                false,
                                brickCategory,
                                brickSubCategory,
                                brickName
                              )
                          }
                          role="button"
                          tabIndex={0}
                        // onClick={e =>
                        //   this.handleRemoveItemDialog(e, request, code, price, discountPercent, location)
                        // }
                        >
                          <Icon
                            icon={luxe ? 'luxe-Delete' : 'icon-Delete'}
                            iconClass={'luxe-delete-icon'}
                            ariaLabel='delete'
                            styles={luxe ? undefined : fleek ? { fontSize: '2rem', color: '#FFF' } : { fontSize: '2rem', color: '#070707' }}
                          />
                        </div>
                        
                        {!sizeDetails && !luxe && (
                          (!isComingSoonEnabled || !isComingSoonProduct) && (
                            <div className={fleek ? 'oos-button fleek-bg' : 'oos-button'}>
                              <span className={fleek ? 'oos-text fleek-text-primary' : 'oos-text'} aria-label='Out of stock'>Out of stock</span>
                            </div>
                          )
                        )}
                        {isComingSoonEnabled && isComingSoonProduct ? (
                          <div className={luxe ? 'luxe-add-to-bag' : 'add-to-bag'} key={code}>
                          <Button
                          size="md"
                          variation="primary"
                          icon={'icon-Notifications'}
                          iconStyles={!luxe && { fontSize: '2rem' }}
                          btnLabel={'Notify Me'}
                          ariaLabel={'Notify Me'}
                          applyAriaLabelToButton={false}
                          fullWidth
                          id={luxe ? `luxe ${code}` : code}
                          onClick={e => this.wishlistSizeDetails(e)}
                        />
                          </div>
                        )
                        : (
                          sizeDetails && (
                            <div className={luxe ? 'luxe-add-to-bag' : 'add-to-bag'} key={code}>
                              <Button
                                size="md"
                                variation="primary"
                                icon={!luxe && 'icon-Bag'}
                                iconStyles={!luxe && { fontSize: '2rem' }}
                                btnLabel={luxe ? 'ADD TO BAG' : addToBag}
                                ariaLabel={luxe ? 'ADD TO BAG' : addToBag}
                                applyAriaLabelToButton={false}
                                fullWidth
                                id={luxe ? `luxe ${code}` : code}
                                onClick={e => this.wishlistSizeDetails(e)}
                              />
                            </div>
                          )
                        )
                      }
                      </div>
                    ) : null}
                    {(enableRushDelivery || enablePriorityDeliveryPhase2) &&
                      deliverySlaTag &&
                      PLP_BUCKET[`${deliverySlaTag}`] &&
                      deviceType === 'mobile' &&
                      pageType === 'plp' && (
                        <div
                          className={
                            fleek
                              ? 'fleek-priority-delivery-container'
                              : 'priority-delivery-container'
                          }
                        >
                          <img
                            className="priority-delivery-icon"
                            alt="Priority Delivery Icon"
                            src={
                              deliveryMethod === DELIVERY_METHOD.RUSH
                                ? replaceWithJioCDN(priorityDeliveryConfig?.RUSH_ICON)
                                : fleek
                                  ? priorityDeliveryConfig?.PD2_TRUCK_ICON_AJIOGRAM
                                  : priorityDeliveryConfig?.PD2_TRUCK_ICON
                            }
                          />
                          <span
                            className={
                              fleek ? 'fleek-priority-delivery-text' : 'priority-delivery-text'
                            }
                          >
                            {PLP_BUCKET[`${deliverySlaTag}`]}
                          </span>
                        </div>
                      )}
                  </div>
                </div>
              </a>
              {!pageTitle ? (
                <div id="plp_wishlist" data-code={code} className={!changeView ? 'wishilistContainer' : 'wishilistContainer wishlistinListView'}>
                  <button
                    className="wishlistBack"
                    tabIndex={0}
                    style={{ border: 'none', background: luxe ? 'transparent' : '#fff' }}
                    onClick={e => {
                      e.preventDefault();
                      segmentEventPush({
                        event: 'Product Wishlisted',
                        event_category: 'add_to_whishlist',
                        event_action: 'added sucessfully',
                        products : [ {
                          ...getProductItemPDP(this.props.entity, rowIndex * 2 + columnIndex)
                        }],          
                        screen_name: 'plp screen',
                      });
                      const itemCode = code.slice(0, 9);
                      const itemPrice = price.value;
                      const itemImage = images[0]?.url;
                      setTimeout(() => {
                        this.wishListApiCall(code, store);
                        getWishlistPriceDropData(itemCode, itemImage, itemPrice);
                      }, 0);
                    }}
                    aria-label={this.state.isWishListed ? `Remove from wishlist ${name?.substring(0, 4)}...` : `Add to wishlist ${name?.substring(0, 4)}...`}
                  >
                    <Icon
                      icon={this.state.isWishListed ? 'icon-Wishlist_Active' : 'icon-Wishlist'}
                      styles={{
                        fontSize: '1.8rem',
                        zIndex: 1,
                        color: this.state.isWishListed && !luxe ? '#f97676' : '#202020',
                        fontWeight: 'bold',
                        marginTop: '2.5px',
                        marginLeft: '1px'
                      }}
                      // ariaHidden={true}
                    />
                  </button>
                </div>
              ) : null}
            </div>
          ) : (
            <div id={rowIndex}>
              <a
                className="rilrtl-products-list__link desktop"
                href={
                  pageType === 'wishlist'
                    ? productUrl
                    : `${addCustomerType(url)}${addCustomerType(url).includes('?') ? '&' : '?'}${isCopilotReferrer() ? 'plp_source_details=ai_assistant_widget' : ''}`
                }
                target={'_blank'}
                onClick={(e) => {
                  const isQuickView = e.target?.getAttribute('aria-label') === 'Quick View';

                  const fireAnalytics = () => {
                    if (newDesignLuxe) {
                      let itm_source_detail = '';
                      if(isCopilotReferrer()){
                        itm_source_detail = 'ai_assistant_widget'
                      }
                      luxeGtmProductClick({
                        name,
                        id: productId,
                        price: value,
                        wasProductPrice: mp,
                        brand: brandName,
                        position,
                        category: brickCategory || '',
                        product_size: sizeDetails,
                        product_color: color,
                        product_trade_discount: discountPercent,
                        product_brick: isNaN(brickName) ? brickName : '',
                        product_tag: tag,
                        list: screenName,
                        store_type: currentStore,
                        pageType: screenType,
                        pageName: screenName,
                        sourceStore:
                          pageType !== 'wishlist' || sourceStoreId === 'luxe'
                            ? currentStore
                            : defaultStore,
                        containsLuxe: pageType !== 'wishlist' || sourceStoreId === 'luxe' ? true : false,
                        showPlpExtendedBanner: showPlpExtendedBanner && !priceRevealState,
                        productTagEngineValue: pageType !== 'wishlist' && getVariant('enable_urgency_driver_plp') ? productTagEngineValue : productTag,
                        productPriceLabel: pageType !== 'wishlist' && getVariant('enable_urgency_driver_plp') ? productPriceLabel : '',
                        catalog: catalogueOfProduct,
                        segmentId: segmentId,
                        experimentId: experimentId,
                        sourcePage,
                        jioAdsSource,
                        offerName: gwpDimension,
                        itm_source_detail,
                        adsData,
                        code,
                        skuId: variantOptions?.[0]?.code || code || ''
                      });
                    } else {
                      if (onClickProduct) onClickProduct();
                      trackProductItemClick({
                        position,
                        code,
                        price,
                        discountPercent,
                        location,
                        entity,
                        showPlpExtendedBanner: showPlpExtendedBanner && !priceRevealState,
                        pageTypeCard: pageType,
                        averageRating,
                        ratingCount: pageType === 'wishlist' ? numUserRatings : ratingCount,
                        freeTextSearch,
                        sourcePage,
                        jioAdsSource,
                        gwpDimension,
                      previousSource,
                      isQuickView: isQuickView,
                      osmosClientId: osmosClientId || ''
                      });
                    }
                  };

                  if (enablePlpInpV1) {
                    if ('requestIdleCallback' in window) {
                      requestIdleCallback(fireAnalytics, { timeout: 2000 });
                    } else {
                      setTimeout(fireAnalytics, 0);
                    }
                  } else {
                    fireAnalytics();
                  }
                }}
                aria-label={`${brandName} ${name}. 
                  ${(hideMRP && orginalPrice !== finalPrice
                    ? `Current price; ${displayValueWithoutDecimal(dodFinalPrice)}. MRP ${displayValueWithoutDecimal(orginalPrice)}. ` +
                      `${
                        isDODEnabled
                          ? `${dodDiscountPercent} discount available.`
                          : parseInt(discountPercent) > 0
                          ? `${discountPercent} discount available.`
                          : ''
                      }`
                    : `Price ${displayValueWithoutDecimal(dodFinalPrice)}`)}
                `}
              >
                <div
                  className="preview"
                  ref={productListContainer => {
                    this.productListContainer = productListContainer;
                  }}
                  aria-hidden='true'
                >
                  <div className="imgHolder" style={{backgroundImage: `url(${`${imageBaseUrl}/static/img/plp.png`})`}}>
                    <InView as="div" key={code} className={`${code}`} threshold={0.5} triggerOnce={true} onChange={(inView, entry) => this.inViewOnChangeHandler({ isInView: inView, productId: code })}>
                    {isComingSoonEnabled ? this.renderImage({
                      imageURL,
                      altTxt: `Product image of ${brandName} ${name}`,
                      productListContainer: this.productListContainer,
                      productTag: productTagValue
                    }) : this.renderImage({
                      imageURL,
                      altTxt: `Product image of ${brandName} ${name}`,
                      productListContainer: this.productListContainer,
                    })
                  }
                    </InView>
                    {!sizeDetails && pageTitle && (
                       isComingSoonEnabled ? (
                        !isComingSoonProduct ? (
                          <div className="rilrtl-out-of-stock">
                            <span aria-label='Product is Out of Stock'>Product is Out of Stock</span>
                          </div>
                        ) : null
                      ) : (
                        (
                          <div className="rilrtl-out-of-stock">
                            <span aria-label='Product is Out of Stock'>Product is Out of Stock</span>
                          </div>
                        )
                      )
                    )}                
                    {!isComingSoonEnabled && (productTagValue || productTagEngineValue) && !showAd ? (
                      <Feature featureName="enable_urgency_driver_plp">
                        <Variant id="0">
                          {productTagValue && <div className="exclusive" aria-label={productTagValue}>{productTagValue}</div>}
                        </Variant>
                        <Variant id="1">
                          {
                            pageType === 'wishlist' ?
                              productTagValue && <div className="exclusive" aria-label={productTagValue}>{productTagValue}</div>
                              : productTagEngineValue && <div className={(newDesignLuxe ? "luxe-exclusive-new " : "exclusive-new ") + (gridColumns == 5 && "with-5-grid")}>{productTagEngineValue}</div>
                          }
                        </Variant>
                      </Feature>
                  ) : null}
            
                    {showAd ? (
                      <div
                        className={`adDisplay ${gridColumns === 5 ? 'fiveProducts' : 'threeProducts'}`}
                      >
                        {adText}
                      </div>
                    ) : null}
                    {newDesignLuxe ?
                      <div id="plp_wishlist" className="wishilistContainer">
                        <div className='wishlistBack' onClick={(e) => {
                          e.preventDefault();
                            segmentEventPush({
                              event: 'Product Wishlisted',
                              event_category: 'add_to_whishlist',
                              event_action: 'added sucessfully',
                              products : [ {
                                 ...getProductItemPDP(this.props.entity,rowIndex*2 + columnIndex)
                              }],          
                              screen_name: 'plp screen',                              
                            });
                            this.wishListApiCall(code, store)
                          }}
                          role="button" tabIndex={0} aria-label={this.state.isWishListed ? `Remove from wishlist ${name?.substring(0, 4)}...` : `Add to wishlist ${name?.substring(0, 4)}...`}>
                          <Icon
                            icon={this.state.isWishListed ? "icon-Wishlist_Active" : "icon-Wishlist"}
                            styles={{
                              fontSize: '2.5rem',
                              zIndex: 1,
                              color: this.state.isWishListed && !luxe ? '#f97676' : '#202020',
                              fontWeight: 'bold'
                            }}
                            ariaHidden={true}
                          />
                        </div>
                      </div>
                      : ""}
                    {!pageTitle && !isDODEnabled && (
                      newDesignLuxe ? (
                        <div className="plp-quick-view-carousel-container">
                          <div className="popUp-container">
                            <div
                              className="popUp" 
                              onClick={e => this.openModal(colorGroup, e)} 
                              onMouseEnter={this.quickViewMouseEnterHandler}
                              aria-label="Quick View"
                              role="button"
                              tabIndex={0}
                            >
                              <div className="quickView-popup" aria-label="Quick View">Quick View</div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div
                          className="popUp"
                          onClick={e => this.openModal(colorGroup, e)}
                          onMouseEnter={this.quickViewMouseEnterHandler}
                          aria-label="Quick View"
                          role="button"
                          tabIndex={0}
                        >
                          Quick View
                        </div>
                      ))}
                      {pageType === 'wishlist' && isComingSoonEnabled && isComingSoonProduct && (
                        <div className="rilrtl-product-size">
                        {newDesignLuxe ?
                          <div className='lexe-bell'
                            tabIndex={0}
                            role='button'
                            aria-label="Select size"
                            onClick={e => {
                              this.addToNotifyWishlist(e,this.props);
                            }}
                          >
                            <img src={`${imageBaseUrl}/static/img/notify_luxe_bell.svg`} alt="" className="wishlist-card-bag" />
                          </div> :
                          <div
                            style={{
                              width: '30px',
                              height: '30px',
                              marginTop: '8px'
                            }}
                            tabIndex={0}
                            role='button'
                            aria-label="Select Size"
                            onClick={e => {
                              this.addToNotifyWishlist(e,this.props);
                            }}
                          >
                            <img src={`${imageBaseUrl}/static/img/notiffy_wishlist.svg`} alt="" className="wishlist-card-bag" />
                          </div>
                        }
                      </div>
                      )}
                    {pageTitle && showSizePopup && (
                        <div className="cart-size-details" ref={this.modalRef} role="dialog" aria-labelledby="size-modal-title">
                          <div className="wishlist-size-title" id="size-modal-title">
                          Select Size
                          <span className="size-format">
                            {sizeDisplayType ? ` (${sizeDisplayType})` : ''}
                          </span>
                        </div>
                        <div
                          className="ic-close-quickview"
                          tabIndex={0}
                          role='button'
                            aria-label="Close"
                            ref={this.closeButtonRef}
                          onClick={e => {
                            e.preventDefault();
                            this.mouseLeaveHandler();
                          }}
                        />
                        <Suspense fallback={null}>
                          <EditSizeUpdate
                            sizeVariantOptions={stateSizeVariantOptions}
                            wishlistPage={true}
                            newSizeRevampFlag={newSizeRevampFlag}
                            showBrandSizeFlag={showBrandSizeFlag}
                            closePopup={this.mouseLeaveHandler}
                            entity={this.props.entity}
                            newDesignLuxe={newDesignLuxe}
                            screenName={screenName}
                            screenType={screenType}
                          />
                        </Suspense>
                      </div>
                    )}

                    {allPromotions ? <div className="sec-prod-offer" style={{backgroundImage: `url(${`${imageBaseUrl}/static/img/sprite_v1.png`})`, backgroundRepeat: 'no-repeat',backgroundPosition: '-60px -112px' }}/> : null}
                  </div>
                  <div className="contentHolder">
                  <div role='heading' aria-level={2}>
                    <div className="brand"><strong>{brandName}</strong></div>
                    <div className={newDesignLuxe ? 'name' : 'nameCls'}>{name}</div>
                    </div>
                    {((getFeatureVariant('rating-label-display-msite-wishlist') !== '0' && pageType === 'wishlist' && enableRatingLabelWishlist) ||
                      (getFeatureVariant('rating-label-display-msite-plp') !== '0' && pageType === 'plp' && enableRatingLabelPLP)) &&
                      (
                        enableRating && averageRating && !luxe &&
                        <AggregatedRatingTag
                          ratingValue={averageRating}
                          totalRatingCount={pageType === 'wishlist' ? numUserRatings : ratingCount}
                          customClass={"rating-label-desktop-plp"}
                          size={'lg'}
                          backGroundColour={averageRating < 3 ? 'red' : 'green'} />
                      )
                    }
                    <div 
                      className={newDesignLuxe ? 'price' : priceSectionClass}
                      aria-label={
                        (hideMRP && orginalPrice !== finalPrice
                          ? `Current discounted price; Rs. ${displayValueWithoutDecimal(dodFinalPrice)}. MRP Rs. ${displayValueWithoutDecimal(orginalPrice)} strike off, ` +
                            `${
                              isDODEnabled
                                ? `${dodDiscountPercent} discount available.`
                                : parseInt(discountPercent) > 0
                                ? `${discountPercent} discount available.`
                                : ''
                            }`
                          : `Rs. ${displayValueWithoutDecimal(dodFinalPrice)}`)
                      }
                    >
                      <span className={`price ${setDodCssForPrice} `} aria-hidden='true' tabIndex={-1}>
                        <strong>{displayValueWithoutDecimal(dodFinalPrice)}</strong>
                      </span>
                      &nbsp;
                      {isDODEnabled ? (
                        hideMRP &&
                        <div className="offer-price" aria-hidden='true' tabIndex={-1}>
                          <span className="orginal-price">{displayValueWithoutDecimal(orginalPrice)}</span>
                          {newDesignLuxe ? (
                            <span className="discount">
                              {' '}
                              {isDODEnabled
                                ? `${dodDiscountPercent}`
                                : parseInt(discountPercent) > 0
                                  ? `${discountPercent}`
                                  : ''}
                            </span>
                          ) : (
                            <span className="discount">
                              {' '}
                              {isDODEnabled
                                ? `(${dodDiscountPercent})`
                                : parseInt(discountPercent) > 0
                                  ? `(${discountPercent})`
                                  : ''}
                            </span>
                          )}
                        </div>
                      ) : orginalPrice == finalPrice ? null : (
                        hideMRP &&
                        <div className="offer-price" aria-hidden='true' tabIndex={-1}>
                          <span className="orginal-price">{displayValueWithoutDecimal(orginalPrice)}</span>
                          {newDesignLuxe ? (
                            <span className="discount">
                              {' '}
                              {isDODEnabled
                                ? `${dodDiscountPercent}`
                                : parseInt(discountPercent) > 0
                                  ? `${discountPercent}`
                                  : ''}
                            </span>
                          ) : (
                            <span className="discount">
                              {' '}
                              {isDODEnabled
                                ? `(${dodDiscountPercent})`
                                : parseInt(discountPercent) > 0
                                  ? `(${discountPercent})`
                                  : ''}
                            </span>
                          )}
                        </div>
                      )}
                    </div>
                    {enableGiftWithProduct &&
                      (pageType === 'wishlist' ? isGiftWithPurchase : giftAvailable) && (
                        <div className='gwp-container'>
                          <span className={luxe ? 'gwp-text-luxe' : 'gwp-text'}>{giftWithProductConfig.productWidgetTitle}</span>
                        </div>
                      )}
                    {!isDODEnabled && priceRevealState && (
                      <PriceRevealPLP
                        priceReveal={priceReveal}
                        orignalPrice={sp}
                        deviceType="desktop"
                        offerValue={offerValue}
                        futureBestPrice={futureBestPrice}
                        luxe={luxe}
                      />
                    )}
                    {!priceRevealState && offerPrice.displayformattedValue && pageTitle !== 'Wishlist' && offerPrice.displayformattedValue != "null" && !newDesignLuxe && sp !== offerValue ?
                      <Feature featureName="enable_urgency_driver_plp">
                        <Variant id="0">
                          {
                            offerPriceShow ?
                              <div className="offer-div-new" >
                                <img src={`${imageBaseUrl}/static/img/percentageForDesktop.svg`} className='offer-icon' alt='Offer icon' />
                                <span className="offer-new" aria-label="Offer price">Offer price</span>&nbsp;
                                <span className="offer-pricess-new">
                                  {Constant.AW_RUPEE_SYMBOL}
                                  {formatPrice(displayformattedValue)}
                                </span>
                              </div>
                              :
                              <div className="offer-div" >
                                <span className="offer" aria-label="Offer price">Offer price</span>&nbsp;
                                <span className="offer-pricess">
                                  {Constant.AW_RUPEE_SYMBOL}
                                  {formatPrice(displayformattedValue)}
                                </span>
                              </div>
                          }
                        </Variant>
                        <Variant id="1">
                          <div className="offer-div-new" >
                            <img src={`${imageBaseUrl}/static/img/percentageForDesktop.svg`} className='offer-icon' alt='Offer icon' />
                            <span className="offer-new">{productPriceLabel ? productPriceLabel : 'Offer Price:'}</span>&nbsp;
                            <span className="offer-pricess-new">
                              {Constant.AW_RUPEE_SYMBOL}
                              {formatPrice(displayformattedValue)}
                            </span>
                          </div>
                        </Variant>
                      </Feature>
                      : <></>
                    }
                    {dealOfDayDom}
                    {newDesignLuxe
                      ? ''
                      : plpSizesFlag && <ShowSizeDetail sizeVariants={sizeVariants} more={more} />}
                  </div>
                </div>
              </a>

                {pageTitle ? (
                  <div
                    className="ic-delete rilrtl-remove-product"
                    aria-label="Remove from wishlist"
                    onClick={e => {
                      if (e) {
                        e.preventDefault();
                        e.stopPropagation();
                      }
                      const reqQuery = { ...request.query };
                      reqQuery.currentPage = 0;
                      const query = buildQuery(reqQuery);
                      let nextRequest = { ...request, query };
                      this.props.removeProductFromWishlist(code, nextRequest);
                      const {
                        wishlist: { screenName = '', screenType = '' }
                      } = luxeScreens;
                      if (newDesignLuxe) {
                        gtmEventPush({
                          event: 'remove_from_closet',
                          event_category: 'wishlist interactions',
                          event_actions: 'remove from closet',
                          page_name: screenName,
                          page_type: screenType,
                          store_type: luxeStore
                        });
                      }
                      this.removeWishlistInLocal(code);
                      trackRemoveItemFromWishList({ code, price, discountPercent, location });
                      console.log("TRACK POINT 3 ~ brickSubCategory:", brickSubCategory)
                      jioAdsRemoveFromWishList({
                        brickCategory: brickCategory || '',
                        brickSubCategory: brickSubCategory || '',
                        brickName: brickName || '',
                        code: colorGroup,
                        price: value,
                        quantity: 1
                      })
                    }}
                    tabIndex={0}
                    role='button'
                  />
                ) : null}

                {pageTitle && sizeDetails ? (
                  <div className="rilrtl-product-size" data-code={id}>
                    {newDesignLuxe ?
                      <div
                        id={name}                  
                        tabIndex={0}
                        role='button'
                        className="ic-cart"
                        aria-label="Select Size"
                        onClick={e => {
                          this.openSizeModal(e);
                          if (newDesignLuxe && showSizePopup) {
                            luxeGtmAddToCart(
                              name,
                              id?.split('_')[0],
                              value,
                              brandName,
                              brickCategory,
                              '',
                              color,
                              discountPercent,
                              brickName,
                              tag,
                              1,
                              screenName,
                              currentStore,
                              screenType,
                              screenName,
                              screenName,
                              currentStore,
                              true,
                              '',
                              segmentId,
                              experimentId,
                              mp
                            );
                            cleverTapPushEvent({
                              eventName: CLEVERTAP_EVENT_NAMES.Added_to_Cart,
                              eventObj: {
                                MRP: mp,
                                Name: name,
                                SKU: colorGroup || code,
                                Brand: brandName,
                                Vertical: verticalName,
                                Final_Price: formattedSp,
                                Brick: brickName,
                                Category: brickCategory || '',
                                Sub_Category: brickSubCategory,
                                Image_URL: images[0] ? images[0].url : '',
                                Size: '',
                                Product_URL: url,
                                Color: '',
                                Catalog_Id: catalogName,
                                user_id: userId != 'null' ? userId : 'anonymous',
                                platform: 'MSITE',
                                source: 'Wishlist'
                              }
                            });
                          }
                        }}
                      ></div> :
                      <div
                        onClick={e => {
                          this.openSizeModal(e, name);
                        }}
                        tabIndex={0}
                        role='button'
                        aria-label="Select Size"
                        id={name}
                      >
                        <img src={`${imageBaseUrl}/static/img/wishlist-bag-icon.svg`} alt="" className="wishlist-card-bag" />
                      </div>
                    }
                    {/* This is causing the UI issue - defect - 480735 */}
                    {/* <div className="size-detail">{sizeDetails}</div> */}
                  </div>
                ) : null}
            </div>
          )}
        </div>
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  const { id, sourcePage, jioAdsSource } = ownProps;
  const { location = {} } = window;
  const { grid = {}, gridPDP = {}, productsAdditionalInfo = {}, modals = {}, request = {}, requestPDP = {}, flags = {}, product: { reqObj = {} } = {}, plpViewType, jioAds = {} } = state;
  const { freeTextSearch } = request;
  const { productToggle = '', priceRevealMetaInfo = {} } = productsAdditionalInfo;
  const { entities = {}, viewType, cacheInvalid = false, gridColumns } = location.pathname.includes("/p/") && reqObj.deviceType === 'mobile' ? gridPDP : grid;   //Removed requestPDP.deviceType== 'mobile'
  const entity = entities[id] || {};
  const modal = modals['cart-size-modal'] || {};
  const productSizeDetails = modal.state ? modal.state.product : {};
  const { sis, name } = state.metaData;
  const plpExtendedBannerData = getPlpExtendedBannerImages(state);
  const { showPlpExtendedBanner = false } = plpExtendedBannerData;
  const previousSource = getPreviousSearchSource(state);
  const osmosSpecs = getAmplitudeVariantPayload('osmosadsspecs', state, {});
  const osmosClientId = osmosSpecs?.clientId || '';
  // console.log("TRACK SIMILAR PRODUCT PRODUCT CARD DESKTOP")
  return {
    ...ownProps,
    productsAdditionalInfo,
    showModal: state.popup.modalPopup,
    entities,
    entity,
    viewType,
    cacheInvalid,
    productToggle,
    productSizeDetails,
    request,
    requestPDP,
    plpSizesFlag: getPlpSizesFlag(flags),
    newSizeRevampFlag: getNewSizeRevampFlag(flags),
    showBrandSizeFlag: getShowBrandSizeFlag(flags),
    luxeFlags: getLuxeFlags(state.flags),
    currentStore: getCurrentStore(state),
    flags,
    priceRevealMetaInfo,
    store: sis ? name : 'AJIO',
    reqObj,
    showPlpExtendedBanner,
    gridColumns,
    freeTextSearch,
    showSimiliarProductFlag: getShowSimilarProducts(state, "", "PLP"),
    viewTypeFlag: getViewTypeFlag(state.flags),
    plpViewType,
    enableRating: getEnableRating(flags, state),
    enableRatingLabelPLP: getEnableRatingLabelPLP(state) === 'ON',
    enableRatingLabelWishlist: getEnableRatingLabelWishlist(state) === 'ON',
    storesForHidingMRP: getStoresForHidingMRP(state),
    ga4AjioEnable: getGA4AJIOEnable(state.flags),
    enableGiftWithProduct: getGiftWithProductEnable(state.flags),
    giftWithProductConfig: getGiftWithProductConfig(state),
    isComingSoonEnabled: getEnableComingSoonProducts(state?.flags),
    enablePriorityDeliveryPhase2: getPriorityDeliveryPhase2Flag(state.flags),
    priorityDeliveryConfig: getPriorityDeliveryConfig(state),
    priorityDeliverySLPTagsConfig: getPriorityDeliverySLPTagsConfig(state),
    enableRushDelivery: getRushDeliveryFlag(state),
    previousSource,
    ajiogramInterventionsConfig: getAjiogramInterventionsConfig(state?.flags),
    urgencyDriverV2PLPEnable: getUrgencyDriverV2PLPEnable(state),
    perfExperiments: true,
    osmosClientId
  };
};
const mapDispatchToProps = dispatch => {
  return {
    openModal: productId => dispatch(actions.openModal(productId)),
    setGridConfig: config => {
      dispatch(setGridConfig(config));
    },
    setGridConfigPDP: config => {
      dispatch(setGridConfigPDP(config));
    },
    removeProductFromWishlist: (productCode, request) =>
      dispatch(removeProductFromWishlist({ data: productCode, request })),
    removeProductFromWishlistPDP: (productCode, request) =>
      dispatch(removeProductFromWishlistPDP({ data: productCode, request })),
    openSizeModal: (variantOptions, sizeDisplayType) =>
      dispatch(openSizeModal(variantOptions, sizeDisplayType)),
    getSizeDetail: code => dispatch(getSizeDetail(code)),
    showLoader: (name, config) => {
      dispatch(showLoader(name, config));
    },
    hideLoader: name => {
      dispatch(hideLoader(name));
    },
    addToWishlistApi: (productId, showMessage) => {
      dispatch(addProductToWishlist(productId, showMessage))
    },
    loadWishlistOptionCodesAPI: () => { loadWishlistOptionCodesAPI() },
    setWishlistNotify: notifyValue => {
      dispatch(setWishlistNotify(notifyValue));
    },
    selectNotifyError: message => dispatch(actions.selectNotifyError(message)),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProductCard));
